{
  "account.account": "Profil & Sicherheit",
  "account.accountDeleted": "Ihr Konto wurde erfolgreich gelöscht.",
  "account.accountDescription": "Name, Passwort, Konto löschen",
  "account.accountSection": "Konto",
  "account.changeEmail": "E-Mail ändern",
  "account.changePassword": "Passwort ändern",
  "account.currentPassword": "Aktuelles Passwort",
  "account.dangerZone": "Kritischer Bereich",
  "account.deleteAccount": "Account löschen",
  "account.deleteAccountConfirmation": "Sicher, dass der Account gelöscht werden soll? Der Vorgang ist unwiderruflich.",
  "account.deleteAccountDescription": "Durch diese Aktion werden Ihr Konto und alle Ihre Informationen gelöscht. Es gibt kein Zurück.",
  "account.emailChange": "E-Mail-Adresse ändern",
  "account.emailChangeConfirmation": "Bestätigung der E-Mail-Änderung",
  "account.emailChangeFailure": "Der Link zur E-Mail-Änderung ist ungültig oder abgelaufen.",
  "account.emailChangeIntro": "Geben Sie Ihre neue E-Mail-Adresse und Ihr aktuelles Passwort ein. Wir senden einen Link an die neue Adresse: Ihre E-Mail-Adresse wird erst geändert, wenn Sie ihn öffnen.",
  "account.emailChangeSuccess": "Ihre E-Mail-Adresse wurde erfolgreich zu {newEmail} geändert.",
  "account.emailChangeSuccessNoAddress": "Ihre E-Mail-Adresse wurde erfolgreich geändert.",
  "account.emailChangeVerificationSent": "Eine Bestätigungs-E-Mail wurde an Ihre neue E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den Link, um die Änderung zu bestätigen.",
  "account.manageAccount": "Konto verwalten",
  "account.newEmailAddress": "Neue E-Mail-Adresse",
  "account.newPassword": "Neues Passwort",
  "account.newPasswordAgain": "Neues Passwort (wiederholen)",
  "account.oldPassword": "Altes Passwort",
  "account.passwordChange": "Passwortänderung",
  "account.passwordChangeDescription": "Halten Sie Ihr Konto sicher",
  "account.passwordUpdated": "Passwort erfolgreich aktualisiert.",
  "account.profile": "Profil",
  "account.profileUpdated": "Profil erfolgreich aktualisiert.",
  "account.signedInAs": "Angemeldet als",
  "account.updateYourProfile": "Profil-Aktualisierung",
  "account.updateYourProfileDescription": "Name und Anzeigeeinstellungen",
  "addons.accountOnHold": "Ihre Kontoverbindung ist abgelaufen. Bitte verbinden Sie sich erneut, um die Datenaktualisierungen fortzusetzen.",
  "addons.accountOnHoldTitle": "Konto pausiert",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Erstellen Sie Ihren API-Schlüssel und rufen Sie ihn über diesen Link ab",
  "addons.ambientWeatherDescription": "Ambient Weather-Wetterstationen (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-Schlüssel",
  "addons.applicationKey": "Anwendungs-Schlüssel",
  "addons.availableServices": "Verfügbar",
  "addons.cannotDisconnectLastAccount": "Ihre einzige Anmeldemethode kann nicht getrennt werden. Bitte fügen Sie zuerst eine andere Anmeldemethode hinzu.",
  "addons.connect": "Verbinden",
  "addons.connected": "Verbunden",
  "addons.connectedAccounts": "Verknüpfte Konten",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Ihre verknüpften Konten werden geladen…",
  "addons.connectedServices": "Verbunden",
  "addons.connectedSince": "Verbunden seit {date}",
  "addons.connectionSection": "Verbindung",
  "addons.connectionSuccess": "{provider}-Konto erfolgreich verbunden",
  "addons.davisApiSecret": "API-Secret",
  "addons.davisApiV2Key": "V2 API-Schlüssel",
  "addons.davisDescription": "Davis Wetterstationen (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Rufen Sie Ihre V2-API-Schlüssel über diesen Link ab",
  "addons.disconnect": "Trennen",
  "addons.disconnectConfirmation": "Möchten Sie Ihr {provider}-Konto wirklich trennen?",
  "addons.disconnectEnergyConfirmation": "SmartMixin beendet die Synchronisierung mit Netatmo Energy und entfernt Ihre Zuhause aus SmartMixin. Ihr Netatmo-Konto und Ihre Geräte sind davon nicht betroffen.",
  "addons.disconnectEnergyDescription": "Beendet die Synchronisierung und entfernt Ihre Zuhause aus SmartMixin.",
  "addons.disconnectionSuccess": "{provider}-Konto erfolgreich getrennt",
  "addons.disconnectProviderDescription": "Beendet die Synchronisierung und löscht die Stationen dieses Dienstes und deren Historie.",
  "addons.disconnectServiceConfirmation": "SmartMixin beendet die Synchronisierung mit {provider} und löscht die Stationen dieses Dienstes samt ihrer gesamten Historie. Ihr {provider}-Konto selbst ist davon nicht betroffen.",
  "addons.disconnectServiceTitle": "{provider} trennen?",
  "addons.ecowittCreateAndRetrieveKeys": "Erstellen Sie einen API-Schlüssel und einen Anwendungs-Schlüssel und rufen Sie beide über diesen Link ab",
  "addons.ecowittDescription": "Ecowitt bietet professionelle Wetterstationen, kabellose Innen-/Außenthermometer, hochpräzise Regenmesser, Luftqualitätssensoren und vieles mehr.",
  "addons.helpLink": "So verbinden Sie {provider}",
  "addons.integrationsSection": "Integrationen",
  "addons.myAcuriteAccountOnHold": "Ihr Konto wurde pausiert. Bitte geben Sie Ihr Passwort ein, um Ihr Konto erneut zu verbinden",
  "addons.myAcuriteDescription": "AcuRite ist die führende Marke für Wetterstationen in Nordamerika. Als führender Anbieter von Zeit-, Temperatur- und Wettertechnologie stellt Ihnen AcuRite detaillierte Informationen über Ihre Innen- und Außenumgebung zur Verfügung, damit Sie Ihren Tag sicher planen können.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Verwenden Sie Ihren Netatmo-Thermostat, um die Temperatur Ihres Hauses von Ihrem Bett oder von überall auf der Welt zu ändern.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Ihre persönliche Wetterstation zu Hause",
  "addons.notConnected": "Nicht verbunden",
  "addons.or": "oder",
  "addons.providerAccountDisconnected": "Die Verbindung zu Ihrem Wetterdienst ist abgelaufen. Bitte verbinden Sie sich erneut, um die Datenaktualisierungen fortzusetzen.",
  "addons.reconnect": "Erneut verbinden",
  "addons.socialConnectionsIntro": "Verknüpfen Sie Ihre sozialen Konten für eine schnelle Anmeldung. Sie können Konten jederzeit verbinden oder trennen.",
  "addons.weatherflowAccessToken": "Zugriffstoken",
  "addons.weatherflowCreateToken": "Erstellen Sie Ihr Token und rufen Sie es über diesen Link ab",
  "addons.weatherflowTempestDescription": "Tempest Wettersystem mit integriertem Windmesser, Regenmesser",
  "addons.weatherServices": "Wetterdienste",
  "addons.weatherServicesConnected": "{count, plural, =0 {Keine Dienste verbunden} one {# Dienst verbunden} other {# Dienste verbunden}}",
  "addons.weatherServicesDescription": "Netatmo, Davis, Weatherflow und mehr verbinden",
  "addons.wundergroundApiKey": "API-Schlüssel",
  "addons.wundergroundDescription": "Weather Underground ist eine globale Gemeinschaft von Menschen, die Daten von Umweltsensoren wie Wetterstationen und Luftqualitätsmonitoren miteinander verbinden, damit wir die reichhaltigen, hyperlokalen Daten bereitstellen können, die Sie benötigen, um Ihre Leidenschaften zu fördern",
  "addons.wundergroundRemoveStationDescription": "Die Station wird aus Ihrem SmartMixin-Konto entfernt. Sofern kein anderes SmartMixin-Konto sie ebenfalls hinzugefügt hat, werden die Station und der von SmartMixin für sie aufgezeichnete Verlauf gelöscht. Bei Weather Underground ändert sich nichts.",
  "addons.wundergroundRemoveStationTitle": "{station} löschen?",
  "addons.wundergroundRetrieveApiKey": "Rufen Sie Ihren API-Schlüssel über diesen Link ab",
  "addons.wundergroundStationId": "Stations-ID",
  "airQuality.adviceActivityGood": "Ein idealer Tag für Aktivitäten im Freien",
  "airQuality.adviceActivityHazardous": "Jede körperliche Aktivität im Freien vermeiden",
  "airQuality.adviceActivityLabel": "Körperliche Aktivität",
  "airQuality.adviceActivityModerate": "Ein guter Tag für Aktivitäten im Freien",
  "airQuality.adviceActivitySensitive": "Kürzere und weniger intensive Aktivitäten im Freien erwägen",
  "airQuality.adviceActivityUnhealthy": "Lange oder intensive Aktivitäten reduzieren und mehr Pausen einlegen",
  "airQuality.adviceActivityVeryUnhealthy": "Lange oder intensive Aktivitäten vermeiden; Verlegung nach drinnen erwägen",
  "airQuality.adviceGroupsGood": "Keine besonderen Vorsichtsmaßnahmen nötig",
  "airQuality.adviceGroupsHazardous": "Drinnen bleiben und die Aktivität gering halten",
  "airQuality.adviceGroupsLabel": "Empfindliche Personengruppen",
  "airQuality.adviceGroupsModerate": "Besonders empfindliche Personen: Aktivitäten kürzer und weniger intensiv gestalten",
  "airQuality.adviceGroupsSensitive": "Aktivitäten im Freien kürzer und weniger intensiv gestalten und mehr Pausen einlegen",
  "airQuality.adviceGroupsUnhealthy": "Lange oder intensive Aktivitäten im Freien vermeiden; Verlegung nach drinnen erwägen",
  "airQuality.adviceGroupsVeryUnhealthy": "Jede körperliche Aktivität im Freien vermeiden; verschieben oder nach drinnen verlegen",
  "airQuality.adviceTimingLabel": "Wann nach draußen",
  "airQuality.adviceTimingMorning": "Bevorzugt am Vormittag – dann ist die Ozonbelastung geringer",
  "airQuality.airQuality": "Luftqualität",
  "airQuality.airQualityIndex": "Index Luftqualität",
  "airQuality.aqiForecast": "Luftqualitätsvorhersage",
  "airQuality.co2Fresh": "Frisch",
  "airQuality.co2GettingStale": "Leicht stickig",
  "airQuality.co2Stale": "Stickig",
  "airQuality.dailyForecast": "Tägliche Vorhersage",
  "airQuality.dominantPollutant": "Dominanter Schadstoff",
  "airQuality.expectedPeak": "Erwarteter Höchstwert",
  "airQuality.good": "Gut",
  "airQuality.goodDescription": "Die Qualität der Luft ist zufriedenstellend. Die Luftverschmutzung stellt ein geringes oder kein Risiko dar.",
  "airQuality.hazardous": "Gesundheitsgefährdend",
  "airQuality.hazardousDescription": "Gesundheitsalarm: Jeder könnte ernstere Auswirkungen auf die Gesundheit verspüren",
  "airQuality.indoorAirQuality": "Luftqualität innen",
  "airQuality.moderate": "Mäßig",
  "airQuality.moderateDescription": "Die Luftqualität ist insgesamt akzeptabel. Bei manchen Schadstoffen bestehen jedoch für einen sehr kleinen Personenkreis, der außergewöhnlich empfindlich auf Luftverschmutzung reagiert, eventuell Gesundheitsbedenken.",
  "airQuality.noForecastForLocation": "Für diesen Ort ist keine Luftqualitätsvorhersage verfügbar.",
  "airQuality.now": "Jetzt",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Schadstoffe",
  "airQuality.recommendations": "Empfehlungen",
  "airQuality.sensitiveUnhealthy": "Ungesund für empfindliche Personengruppen",
  "airQuality.sensitiveUnhealthyDescription": "Bei empfindlichen Personengruppen können gesundheitliche Auswirkungen auftreten. Die allgemeine Öffentlichkeit ist höchstwahrscheinlich nicht betroffen.",
  "airQuality.subIndex": "AQI-Teilindex",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Den Index verstehen",
  "airQuality.unhealthy": "Ungesund",
  "airQuality.unhealthyDescription": "Erste gesundheitliche Auswirkungen können sich bei allen Personengruppen einstellen. Bei empfindlichen Personengruppen können ernstere gesundheitliche Auswirkungen auftreten.",
  "airQuality.veryUnhealthy": "Sehr ungesund",
  "airQuality.veryUnhealthyDescription": "Gesundheitswarnung aufgrund einer Notfallsituation. Die gesamte Bevölkerung ist voraussichtlich betroffen.",
  "alerts.addAlert": "Warnung hinzufügen",
  "alerts.addCondition": "Bedingung hinzufügen",
  "alerts.alertAdded": "Warnung erfolgreich hinzugefügt",
  "alerts.alertAuthorizationNotice": "Warnungen funktionieren nur, wenn Sie SmartMixin autorisieren, Benachrichtigungen anzuzeigen",
  "alerts.alertDeleted": "Warnung erfolgreich gelöscht",
  "alerts.alertName": "Name der Warnung",
  "alerts.alertWhen": "Ich möchte benachrichtigt werden, wenn:",
  "alerts.aqiGreaterThan": "AQI größer als",
  "alerts.aqiGreaterThanThreshold": "AQI größer als {value}{unit} Schwellenwert",
  "alerts.aqiLessThan": "AQI kleiner als",
  "alerts.aqiLessThanThreshold": "AQI kleiner als {value}{unit} Schwellenwert",
  "alerts.atLeastOneCondition": "Sie müssen mindestens eine Bedingung hinzufügen",
  "alerts.co2GreaterThan": "CO2 größer als",
  "alerts.co2GreaterThanThreshold": "CO2 größer als {value}{unit} Schwellenwert",
  "alerts.co2LessThan": "CO2 kleiner als",
  "alerts.co2LessThanThreshold": "CO2 kleiner als {value}{unit} Schwellenwert",
  "alerts.conditions": "Bedingungen",
  "alerts.conditionsDroppedOnStationChange": "Von dieser Station nicht unterstützt und entfernt: {conditions}",
  "alerts.createAlert": "Warnung erstellen",
  "alerts.dailyPrecipitationGreaterThan": "Tagesniederschlag größer als",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Tagesniederschlag über dem Schwellenwert von {value}{unit}",
  "alerts.deleteAlert": "Warnung löschen",
  "alerts.editAlert": "Warnung bearbeiten",
  "alerts.editCondition": "Bedingung bearbeiten",
  "alerts.gustSpeedGreaterThan": "Böengeschwindigkeit größer als",
  "alerts.gustSpeedGreaterThanThreshold": "Böengeschwindigkeit größer als {value}{unit} Schwellenwert",
  "alerts.gustSpeedLessThan": "Böengeschwindigkeit kleiner als",
  "alerts.gustSpeedLessThanThreshold": "Böengeschwindigkeit kleiner als {value}{unit} Schwellenwert",
  "alerts.heatIndexGreaterThan": "Hitze-Index größer als",
  "alerts.heatIndexGreaterThanThreshold": "Hitze-Index größer als {value}{unit} Schwellenwert",
  "alerts.heatIndexLessThan": "Hitze-Index kleiner als",
  "alerts.heatIndexLessThanThreshold": "Hitze-Index kleiner als {value}{unit} Schwellenwert",
  "alerts.humidexGreaterThan": "Humidex größer als",
  "alerts.humidexGreaterThanThreshold": "Humidex größer als {value}{unit} Schwellenwert",
  "alerts.humidexLessThan": "Humidex kleiner als",
  "alerts.humidexLessThanThreshold": "Humidex kleiner als {value}{unit} Schwellenwert",
  "alerts.humidityGreaterThan": "Luftfeuchtigkeit größer als",
  "alerts.humidityGreaterThanThreshold": "Luftfeuchtigkeit größer als {value}{unit} Schwellenwert",
  "alerts.humidityLessThan": "Luftfeuchtigkeit kleiner als",
  "alerts.humidityLessThanThreshold": "Luftfeuchtigkeit kleiner als {value}{unit} Schwellenwert",
  "alerts.inProgress": "Läuft",
  "alerts.leafWetnessGreaterThan": "Blattnässe größer als",
  "alerts.leafWetnessGreaterThanThreshold": "Blattnässe größer als {value}{unit} Schwellenwert",
  "alerts.leafWetnessLessThan": "Blattnässe kleiner als",
  "alerts.leafWetnessLessThanThreshold": "Blattnässe kleiner als {value}{unit} Schwellenwert",
  "alerts.myAlerts": "Meine Warnungen",
  "alerts.noConfiguredAlert": "Sie haben noch keine Warnungen konfiguriert, fangen Sie an, eine hinzuzufügen",
  "alerts.noiseGreaterThan": "Lärm größer als",
  "alerts.noiseGreaterThanThreshold": "Lärm größer als {value}{unit} Schwellenwert",
  "alerts.noiseLessThan": "Lärm kleiner als",
  "alerts.noiseLessThanThreshold": "Lärm kleiner als {value}{unit} Schwellenwert",
  "alerts.noteOnConditions": "Beachten Sie, dass die Warnung ausgelöst wird, wenn alle der folgenden Bedingungen erfüllt sind",
  "alerts.noTriggerHistory": "Dieser Alarm wurde noch nicht ausgelöst.",
  "alerts.pm10GreaterThan": "PM 10 größer als",
  "alerts.pm10GreaterThanThreshold": "PM 10 größer als {value}{unit} Schwellenwert",
  "alerts.pm10LessThan": "PM 10 kleiner als",
  "alerts.pm10LessThanThreshold": "PM 10 weniger als {value}{unit} Schwellenwert",
  "alerts.pm1GreaterThan": "PM 1 größer als",
  "alerts.pm1GreaterThanThreshold": "PM 1 größer als {value}{unit} Schwellenwert",
  "alerts.pm1LessThan": "PM 1 kleiner als",
  "alerts.pm1LessThanThreshold": "PM 1 weniger als {value}{unit} Schwellenwert",
  "alerts.pm2p5GreaterThan": "PM 2,5 größer als",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 größer als {value}{unit} Schwellenwert",
  "alerts.pm2p5LessThan": "PM 2,5 kleiner als",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 weniger als {value}{unit} Schwellenwert",
  "alerts.postStormSummary": "Regenereignis-Zusammenfassung",
  "alerts.postStormSynopsisHelper": "Sie erhalten nach jedem Regenereignis eine zusammenfassende Benachrichtigung.",
  "alerts.postStormSynopsisSoleCondition": "Eine Regenereignis-Zusammenfassung kann nicht mit anderen Bedingungen kombiniert werden.",
  "alerts.precipitationGreaterThan": "Stündlicher Niederschlag größer als",
  "alerts.precipitationGreaterThanThreshold": "Stündlicher Niederschlag über dem Schwellenwert von {value}{unit}",
  "alerts.pressureGreaterThan": "Druck größer als",
  "alerts.pressureGreaterThanThreshold": "Druck größer als {value}{unit} Schwellenwert",
  "alerts.pressureLessThan": "Druck kleiner als",
  "alerts.pressureLessThanThreshold": "Druck kleiner als {value}{unit} Schwellenwert",
  "alerts.rainRateGreaterThan": "Regenrate größer als",
  "alerts.rainRateGreaterThanThreshold": "Regenrate über dem Schwellenwert von {value}{unit}",
  "alerts.sensorNotReporting": "Dieser Sensor sendet gerade keine Daten. Die Warnung wird fortgesetzt, sobald er wieder sendet.",
  "alerts.soilMoistureGreaterThan": "Bodenfeuchte größer als",
  "alerts.soilMoistureGreaterThanThreshold": "Bodenfeuchte größer als {value}{unit} Schwellenwert",
  "alerts.soilMoistureLessThan": "Bodenfeuchte kleiner als",
  "alerts.soilMoistureLessThanThreshold": "Bodenfeuchte kleiner als {value}{unit} Schwellenwert",
  "alerts.solarRadiationGreaterThan": "Sonneneinstrahlung größer als",
  "alerts.solarRadiationGreaterThanThreshold": "Sonneneinstrahlung größer als {value}{unit} Schwellenwert",
  "alerts.solarRadiationLessThan": "Sonneneinstrahlung kleiner als",
  "alerts.solarRadiationLessThanThreshold": "Sonneneinstrahlung kleiner als {value}{unit} Schwellenwert",
  "alerts.stationNoLongerReports": "Diese Station sendet keine Daten mehr, daher kann diese Warnung nicht ausgelöst werden.",
  "alerts.stormChartUnavailable": "Der Regenverlauf für dieses Regenereignis ist nicht verfügbar.",
  "alerts.stormDetail": "Regenereignis-Zusammenfassung",
  "alerts.stormDuration": "Dauer",
  "alerts.stormEnd": "Ende",
  "alerts.stormPeakRate": "Maximale Regenrate",
  "alerts.stormStart": "Beginn",
  "alerts.stormTotal": "Gesamtniederschlag",
  "alerts.temperatureGreaterThan": "Temperatur größer als",
  "alerts.temperatureGreaterThanThreshold": "Temperatur größer als {value}{unit} Schwellenwert",
  "alerts.temperatureLessThan": "Temperatur kleiner als",
  "alerts.temperatureLessThanThreshold": "Temperatur kleiner als {value}{unit} Schwellenwert",
  "alerts.thresholdOutOfRange": "Muss zwischen {min} und {max} liegen",
  "alerts.thswGreaterThan": "THSW größer als",
  "alerts.thswGreaterThanThreshold": "THSW größer als {value}{unit} Schwellenwert",
  "alerts.thswLessThan": "THSW kleiner als",
  "alerts.thswLessThanThreshold": "THSW kleiner als {value}{unit} Schwellenwert",
  "alerts.thwGreaterThan": "THW größer als",
  "alerts.thwGreaterThanThreshold": "THW größer als {value}{unit} Schwellenwert",
  "alerts.thwLessThan": "THW kleiner als",
  "alerts.thwLessThanThreshold": "THW kleiner als {value}{unit} Schwellenwert",
  "alerts.triggerHistory": "Alarmverlauf",
  "alerts.uvGreaterThan": "UV-Index größer als",
  "alerts.uvGreaterThanThreshold": "UV-Index größer als {value}{unit} Schwellenwert",
  "alerts.uvLessThan": "UV-Index kleiner als",
  "alerts.uvLessThanThreshold": "UV-Index kleiner als {value}{unit} Schwellenwert",
  "alerts.visibilityGreaterThanThreshold": "Sichtbarkeit größer als {value}{unit} Schwellenwert",
  "alerts.visibilityLessThanThreshold": "Sichtbarkeit kleiner als {value}{unit} Schwellenwert",
  "alerts.visiblityGreaterThan": "Sichtbarkeit größer als",
  "alerts.visiblityLessThan": "Sichtbarkeit kleiner als",
  "alerts.whichMeasure": "Für welchen Messwert möchten Sie gewarnt werden?",
  "alerts.whichModule": "Für welches Modul möchten Sie gewarnt werden?",
  "alerts.whichSensor": "Für welchen Sensor möchten Sie gewarnt werden?",
  "alerts.windChillGreaterThan": "Windchill größer als",
  "alerts.windChillGreaterThanThreshold": "Windchill größer als {value}{unit} Schwellenwert",
  "alerts.windChillLessThan": "Windchill kleiner als",
  "alerts.windChillLessThanThreshold": "Windchill kleiner als {value}{unit} Schwellenwert",
  "alerts.windSpeedGreaterThan": "Windgeschwindigkeit größer als",
  "alerts.windSpeedGreaterThanThreshold": "Windgeschwindigkeit größer als {value}{unit} Schwellenwert",
  "alerts.windSpeedLessThan": "Windgeschwindigkeit kleiner als",
  "alerts.windSpeedLessThanThreshold": "Windgeschwindigkeit kleiner als {value}{unit} Schwellenwert",
  "appUpdate.updateAvailable": "Update verfügbar",
  "appUpdate.updateAvailableOpenAppStore": "Tippen Sie, um den App Store zu öffnen",
  "appUpdate.updateAvailableOpenGooglePlay": "Tippen Sie, um Google Play zu öffnen",
  "appUpdate.updateAvailableVersion": "Update verfügbar: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Ein Upgrade Ihrer Anwendung ist erforderlich. Prüfen Sie auf Updates bei Google Play.",
  "appUpdate.upgradeRequiredIos": "Ein Upgrade Ihrer Anwendung ist erforderlich. Prüfen Sie auf Updates im App Store.",
  "astral.aboveHorizonAllDay": "Ganztägig über dem Horizont",
  "astral.aboveTheHorizon": "über dem Horizont",
  "astral.apparentSize": "Winkelgröße",
  "astral.apparentSizeAcross": "{size} Durchmesser",
  "astral.astronomicalDawn": "Astronomische Morgendämmerung",
  "astral.astronomicalDusk": "Astronomische Abenddämmerung",
  "astral.belowHorizonAllDay": "Ganztägig unter dem Horizont",
  "astral.belowHorizonSince": "Unter dem Horizont seit {time}",
  "astral.belowHorizonSinceOn": "Unter dem Horizont seit {day} {time}",
  "astral.brightAllNight": "Die ganze Nacht hell — nie völlig dunkel",
  "astral.brightestMoment": "Hellster Moment",
  "astral.civilDawn": "Bürgerliche Morgendämmerung",
  "astral.civilDusk": "Bürgerliche Abenddämmerung",
  "astral.darkSkyBetween": "Dunkler Himmel {from} → {to}",
  "astral.darkSkyWindow": "Dunkler Himmel {from} → {to} · {duration} ohne Mond",
  "astral.dayLength": "Tageslänge",
  "astral.daylightThroughTheYear": "Tageslänge im Jahresverlauf",
  "astral.dayOfCycle": "Tag {day} von {total}",
  "astral.doesNotOccurToday": "Findet heute nicht statt",
  "astral.domeHint": "Ziehen, um durch die Nacht zu gehen",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Frühester Sonnenaufgang",
  "astral.earliestSunset": "Frühester Sonnenuntergang",
  "astral.equinox": "Tagundnachtgleiche",
  "astral.equinoxIn": "Tagundnachtgleiche in {days, plural, one {# Tag} other {# Tagen}}",
  "astral.evening": "Abend",
  "astral.exactPhaseAt": "Exakt um {time}",
  "astral.firstQuarter": "Erstes Viertel",
  "astral.firstSunriseIn": "Erster Sonnenaufgang in {days, plural, one {# Tag} other {# Tagen}}",
  "astral.firstSunsetIn": "Erster Sonnenuntergang in {days, plural, one {# Tag} other {# Tagen}}",
  "astral.fullMoon": "Vollmond",
  "astral.goldenHourBegins": "Beginn der goldenen Stunde",
  "astral.goldenHourEnds": "Ende der goldenen Stunde",
  "astral.highestPoint": "Höchststand",
  "astral.inDays": "in {days, plural, one {# Tag} other {# Tagen}}",
  "astral.lastQuarter": "Letztes Viertel",
  "astral.latestSunrise": "Spätester Sonnenaufgang",
  "astral.latestSunset": "Spätester Sonnenuntergang",
  "astral.litShort": "Beleucht.",
  "astral.longestDay": "Längster Tag",
  "astral.lowestPoint": "Tiefststand",
  "astral.maxAltitudeShort": "Max",
  "astral.midday": "Mittag",
  "astral.midnightSun": "Mitternachtssonne",
  "astral.midnightSunPeriod": "Mitternachtssonne",
  "astral.milestoneFootnotePolar": "Hier geht die Sonne an {days, plural, one {# Tag} other {# Tagen}} im Jahr weder auf noch unter, deshalb zeigt die Liste statt der üblichen Extreme von Auf- und Untergang, wann das der Fall ist.",
  "astral.milestoneFootnoteTemperate": "Der früheste Sonnenuntergang und der späteste Sonnenaufgang fallen nicht auf den kürzesten Tag — die Zeitgleichung, nicht die Sonnenwende, bestimmt diese beiden Daten.",
  "astral.moon": "Mond",
  "astral.moonAltitude": "Höhe",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Entfernung",
  "astral.moonlessFor": "{duration} ohne Mond",
  "astral.moonPhases": "Mondphasen",
  "astral.moonrise": "Mondaufgang",
  "astral.moonset": "Monduntergang",
  "astral.moonUpAllNight": "Der Mond steht die ganze Nacht am Himmel",
  "astral.moonWashesOutNight": "Der Mond steht von {rise} bis {set} am Himmel und hellt die ganze Nacht auf",
  "astral.morning": "Morgen",
  "astral.nauticalDawn": "Nautische Morgendämmerung",
  "astral.nauticalDusk": "Nautische Abenddämmerung",
  "astral.newMoon": "Neumond",
  "astral.nextDay": "+1 Tag",
  "astral.nextProperlyDarkNight": "Nächste wirklich dunkle Nacht",
  "astral.nextRise": "nächster Aufgang um {time}",
  "astral.nextRiseOn": "nächster Aufgang {day} um {time}",
  "astral.nextSevenNights": "Die nächsten sieben Nächte",
  "astral.nightDate": "Datum",
  "astral.noAstronomicalDarknessTonight": "Keine astronomische Dunkelheit heute Nacht",
  "astral.noDarkNightAhead": "Keine in den nächsten zwei Wochen",
  "astral.noStationLocation": "Standort unbekannt",
  "astral.noStationLocationDescription": "Für diese Station ist keine Position hinterlegt, daher können Sonne und Mond für sie nicht berechnet werden.",
  "astral.noSunriseToday": "Heute kein Sonnenaufgang",
  "astral.nowAtBearing": "jetzt {altitude} · Azimut {direction}",
  "astral.observing": "Beobachten",
  "astral.ofDaylightLeft": "Tageslicht übrig",
  "astral.overTheNextThreeWeeks": "in den nächsten 3 Wochen",
  "astral.percentLit": "{percent} beleuchtet",
  "astral.polarNight": "Polarnacht",
  "astral.polarNightPeriod": "Polarnacht",
  "astral.rightNow": "Jetzt",
  "astral.riseShort": "Aufgang",
  "astral.setShort": "Untergang",
  "astral.shortestDay": "Kürzester Tag",
  "astral.solarNoon": "Sonnenhöchststand",
  "astral.solstice": "Sonnenwende",
  "astral.sunBelowHorizon": "Sonne {degrees}° unter dem Horizont",
  "astral.sunEvents": "Sonnenereignisse",
  "astral.sunNeverDarkEnough": "Die Sonne sinkt nie 18° unter den Horizont",
  "astral.sunNeverSets": "Die Sonne geht nicht unter",
  "astral.sunrise": "Sonnenaufgang",
  "astral.sunriseAndSunset": "Sonnenaufgang und -untergang",
  "astral.sunriseAt": "Sonnenaufgang um {time}",
  "astral.sunset": "Sonnenuntergang",
  "astral.sunsetAt": "Sonnenuntergang um {time}",
  "astral.thisYearAtNorth": "Dieses Jahr auf {degrees}° N",
  "astral.thisYearAtSouth": "Dieses Jahr auf {degrees}° S",
  "astral.tonight": "Heute Nacht",
  "astral.twilightAllNight": "Die ganze Nacht Dämmerung — nie völlig dunkel",
  "astral.upFor": "{duration} über dem Horizont",
  "astral.usableLight": "Nutzbares Licht",
  "astral.vsAverage": "{percent} ggü. Durchschnitt",
  "astral.vsYesterday": "ggü. gestern",
  "astral.waningCrescent": "Abnehmende Mondsichel",
  "astral.waningGibbous": "Abnehmender Dreiviertelmond",
  "astral.waxingCrescent": "Zunehmende Mondsichel",
  "astral.waxingGibbous": "Zunehmender Dreiviertelmond",
  "astral.whereToLook": "Wo suchen",
  "astral.withoutTheMoon": "{duration} ohne Mond",
  "auth.alreadyHaveAccount": "Haben Sie bereits ein Konto?",
  "auth.authContainerTagline": "Ihr persönliches Wetter-Dashboard. Verbinden Sie Ihre Stationen und erhalten Sie Echtzeitdaten auf einen Blick.",
  "auth.backToLogin": "Zurück zum Login",
  "auth.checkYourEmail": "Überprüfen Sie Ihre E-Mail",
  "auth.continueWithApple": "Mit Apple fortfahren",
  "auth.continueWithFacebook": "Mit Facebook fortfahren",
  "auth.continueWithGoogle": "Mit Google fortfahren",
  "auth.email": "E-Mail-Adresse",
  "auth.emailRequiredLoginFacebook": "Die Berechtigung zur Freigabe der E-Mail-Adresse ist erforderlich.",
  "auth.emailVerification": "E-Mail-Verifizierung",
  "auth.emailVerificationFailure": "Während der E-Mail-Überprüfung ist ein Fehler aufgetreten.",
  "auth.emailVerificationSuccess": "Ihre E-Mail-Adresse wurde erfolgreich überprüft.",
  "auth.firstName": "Vorname",
  "auth.forgotPassword": "Passwort vergessen",
  "auth.forgotPasswordSubtitle": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
  "auth.lastName": "Nachname",
  "auth.login": "Anmelden",
  "auth.loginSubtitle": "Willkommen zurück! Bitte geben Sie Ihre Daten ein.",
  "auth.loginToSmartMixinDescription": "Melden Sie sich bei SmartMixin an, um auf Ihre Wetterstationen zuzugreifen, Analysen anzusehen und Ihr persönliches Wetter-Dashboard zu verwalten.",
  "auth.logout": "Abmelden",
  "auth.logoutConfirmation": "Möchten Sie sich abmelden?",
  "auth.noAccountYet": "Haben Sie noch kein Konto?",
  "auth.or": "oder",
  "auth.password": "Passwort",
  "auth.passwordReset": "Passwort wiederherstellen",
  "auth.passwordResetSuccess": "Wiederherstellung des Passworts erfolgreich.",
  "auth.register": "Registrieren",
  "auth.registerDescription": "Erstellen Sie ein kostenloses SmartMixin-Konto, um Ihre Wetterstationen zu verbinden, Wetterdaten zu verfolgen und auf leistungsstarke Analysetools zuzugreifen.",
  "auth.registerSubtitle": "Erstellen Sie Ihr Konto, um loszulegen.",
  "auth.restorePassword": "Passwort wiederherstellen",
  "auth.restorePasswordSuccess": "Wir haben Ihnen gerade einen Link zum Zurücksetzen des Passworts unter {emailAddress} mit weiteren Anweisungen gesendet.",
  "auth.sendReset": "Anweisungen zum Zurücksetzen senden",
  "auth.signInWithApple": "Mit Apple anmelden",
  "auth.socialAccount": "oder verwenden Sie Ihr Konto",
  "auth.staffVerificationCode": "Bestätigungscode",
  "auth.staffVerificationExpiresIn": "Bestätigt. Läuft in {duration} ab.",
  "auth.staffVerificationInvalidCode": "Falscher Code. Bitte erneut versuchen.",
  "auth.staffVerificationLoginAsStopped": "Login As wurde beendet: Geben Sie auf dem Debug-Bildschirm einen Bestätigungscode ein, um fortzufahren.",
  "auth.staffVerificationNotEnrolled": "Für Ihr Konto ist keine Authenticator-App eingerichtet. Fügen Sie eine in den Sicherheitseinstellungen des Backoffice hinzu.",
  "auth.staffVerificationPrompt": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App oder einen Wiederherstellungscode ein, um Login As und die Benutzersuche zu verwenden.",
  "auth.staffVerificationSetupLink": "Authenticator-App hinzufügen",
  "auth.staffVerificationSubmit": "Bestätigen",
  "auth.staffVerificationTitle": "Mitarbeiter-Verifizierung",
  "calendar.afternoon": "Nachmittag",
  "calendar.april": "April",
  "calendar.august": "August",
  "calendar.changePeriod": "Zeitraum: {period}. Zeitraum ändern",
  "calendar.currentDay": "Aktueller Tag",
  "calendar.dateFormat": "Datumsformat",
  "calendar.day": "Tag",
  "calendar.december": "Dezember",
  "calendar.durationHours": "{hours} Std.",
  "calendar.durationHoursMinutes": "{hours} Std. {minutes} Min.",
  "calendar.durationMinutes": "{minutes} Min.",
  "calendar.durationMinutesSeconds": "{minutes} Min. {seconds} Sek.",
  "calendar.durationSeconds": "{seconds} Sek.",
  "calendar.earlierYears": "Frühere Jahre",
  "calendar.endTime": "Endzeit",
  "calendar.evening": "Abend",
  "calendar.february": "Februar",
  "calendar.goToNextDay": "Nächster Tag",
  "calendar.goToNextMonth": "Nächster Monat",
  "calendar.goToNextWeek": "Nächste Woche",
  "calendar.goToNextYear": "Nächstes Jahr",
  "calendar.goToPreviousDay": "Vorheriger Tag",
  "calendar.goToPreviousMonth": "Vorheriger Monat",
  "calendar.goToPreviousWeek": "Vorherige Woche",
  "calendar.goToPreviousYear": "Vorheriges Jahr",
  "calendar.hour": "Stunde",
  "calendar.hoursCount": "{count, plural, one {# Stunde} other {# Stunden}}",
  "calendar.hoursShort": "Std.",
  "calendar.hoursShortCount": "{count, plural, one {# Std.} other {# Std.}}",
  "calendar.january": "Januar",
  "calendar.july": "Juli",
  "calendar.june": "Juni",
  "calendar.last12Hours": "Letzte 12 Stunden",
  "calendar.last24Hours": "Letzte 24 Stunden",
  "calendar.last30Days": "Letzte 30 Tage",
  "calendar.last3Hours": "Letzte 3 Stunden",
  "calendar.last6Hours": "Letzte 6 Stunden",
  "calendar.last7Days": "Letzte 7 Tage",
  "calendar.lastHour": "Letzte Stunde",
  "calendar.laterYears": "Spätere Jahre",
  "calendar.march": "März",
  "calendar.max": "Max",
  "calendar.may": "Mai",
  "calendar.month": "Monat",
  "calendar.monthTotal": "Monatssumme",
  "calendar.morning": "Morgen",
  "calendar.nextHours": "Die nächsten Stunden",
  "calendar.night": "Nacht",
  "calendar.november": "November",
  "calendar.october": "Oktober",
  "calendar.oneDay": "1 Tag",
  "calendar.oneHour": "1 Stunde",
  "calendar.oneMonth": "1 Monat",
  "calendar.oneWeek": "1 Woche",
  "calendar.periodRangeSpoken": "{start} bis {end}",
  "calendar.previous24Hours": "Vorherige 24 Stunden",
  "calendar.previous30Days": "Vorherige 30 Tage",
  "calendar.previous7Days": "Vorherige 7 Tage",
  "calendar.previousDay": "Vorheriger Tag",
  "calendar.previousHours": "Vorherige Stunden",
  "calendar.previousMonth": "Vorheriger Monat",
  "calendar.previousWeek": "Vorherige Woche",
  "calendar.previousYear": "Vorheriges Jahr",
  "calendar.sameDayLastYear": "Gleiches Datum im Vorjahr",
  "calendar.sameMonthLastYear": "Gleicher Monat im Vorjahr",
  "calendar.selectADate": "Wählen Sie ein Datum",
  "calendar.selectAggregation": "Angezeigten Wert auswählen",
  "calendar.selectAMonth": "Wählen Sie einen Monat",
  "calendar.selectAYear": "Wählen Sie ein Jahr",
  "calendar.selectGranularity": "Granularität auswählen",
  "calendar.selectPeriod": "Wählen Sie einen Zeitraum",
  "calendar.september": "September",
  "calendar.sixHours": "6 Stunden",
  "calendar.startTime": "Startzeit",
  "calendar.thirtyMinutes": "30 Minuten",
  "calendar.threeHours": "3 Stunden",
  "calendar.timezone": "Zeitzone",
  "calendar.today": "Heute",
  "calendar.untilChanged": "Bis zur Änderung",
  "calendar.untilTime": "Bis {time}",
  "calendar.untilTodayAt": "Bis heute, {time} Uhr",
  "calendar.untilTomorrowAt": "Bis morgen, {time} Uhr",
  "calendar.use24HourFormat": "24-Stunden-Format verwenden",
  "calendar.week": "Woche",
  "calendar.year": "Jahr",
  "calendar.yearToDate": "Seit Jahresbeginn",
  "calendar.yesterday": "Gestern",
  "charts.averageOverThePeriod": "Durchschnitt über den Zeitraum",
  "charts.calendarView": "Kalenderansicht",
  "charts.charts": "Diagramme",
  "charts.chartView": "Diagrammansicht",
  "charts.comparison": "Vergleich",
  "charts.customizeComparisonMetrics": "Vergleichsmetriken anpassen",
  "charts.customizeComparisonMetricsDescription": "Ziehen Sie Elemente, um Ihre Vergleichsmetriken neu anzuordnen. Tippen Sie auf das Augensymbol, um Metriken ein- oder auszublenden.",
  "charts.loading": "Diagramm wird geladen",
  "charts.maxOverThePeriod": "Maximum über den Zeitraum",
  "charts.measureToDisplay": "Anzuzeigender Messwert",
  "charts.minMaxRange": "Min. / Max.",
  "charts.noDataForThisPeriod": "Keine Daten für den Zeitraum",
  "charts.observations": "Beobachtungen",
  "charts.observedTemperature": "Gemessene Temperatur",
  "charts.seriesTableDate": "Datum",
  "charts.showComparison": "Vergleich anzeigen",
  "charts.stationComparison": "Stationsvergleich",
  "charts.stationComparisonDescription": "Vergleichen Sie historische Wetterdaten mit einer anderen Station",
  "charts.sumOverThePeriod": "Über den Zeitraum kumuliert",
  "charts.tableLabel": "Tabelle: {chart}",
  "charts.toggleSeries": "{series} ein- oder ausblenden",
  "charts.viewAsChart": "Diagramm",
  "charts.viewAsList": "Liste",
  "charts.viewAsPeriods": "Abschnitte",
  "charts.viewAsTable": "Tabelle",
  "charts.viewLabel": "Ansicht: {chart}",
  "common.add": "Hinzufügen",
  "common.altitude": "Höhe",
  "common.analysis": "Analyse",
  "common.average": "Durchschnitt",
  "common.back": "Zurück",
  "common.backToHome": "Zurück zur Startseite",
  "common.cancel": "Abbrechen",
  "common.cannotBeEmpty": "Dieses Feld darf nicht leer sein.",
  "common.close": "Schließen",
  "common.dailyForecast": "Tägliche Vorhersage",
  "common.default": "Standard",
  "common.delete": "Löschen",
  "common.details": "Details",
  "common.edit": "Bearbeiten",
  "common.exitFullscreen": "Vollbild beenden",
  "common.forecast": "Vorhersage",
  "common.frequency": "Frequenz",
  "common.full": "Voll",
  "common.fullscreen": "Vollbild",
  "common.help": "Hilfe",
  "common.hidden": "Ausgeblendet",
  "common.high": "Hoch",
  "common.iDontKnowYet": "Ich weiß es noch nicht",
  "common.indoor": "Innen",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Letztes Update",
  "common.low": "Niedrig",
  "common.maximum": "Maximum",
  "common.medium": "Mittel",
  "common.minimum": "Minimum",
  "common.more": "Mehr",
  "common.moreInformation": "Mehr Informationen",
  "common.next": "Weiter",
  "common.no": "Nein",
  "common.noAccountNeeded": "Kein Konto erforderlich",
  "common.noItemsAvailable": "Keine Einträge verfügbar",
  "common.notNow": "Nicht jetzt",
  "common.now": "Jetzt",
  "common.openSettings": "Einstellungen öffnen",
  "common.outdoor": "Außen",
  "common.pageNotFound": "Seite nicht gefunden",
  "common.pageNotFoundDescription": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
  "common.rain": "Regen",
  "common.reorderCancel": "Verschieben abgebrochen: {item}. Wieder an Position {position} von {count}.",
  "common.reorderEnd": "Abgelegt: {item}. Position {position} von {count}.",
  "common.reorderInstructions": "Um diesen Eintrag zu verschieben, drücken Sie die Leertaste oder die Eingabetaste, wählen Sie mit den Pfeiltasten nach oben und unten seinen Platz und drücken Sie erneut die Leertaste oder die Eingabetaste, um ihn abzulegen, oder Escape, um abzubrechen.",
  "common.reorderOver": "{item}: jetzt an Position {position} von {count}.",
  "common.reorderStart": "Aufgenommen: {item}. Position {position} von {count}.",
  "common.share": "Teilen",
  "common.shareImageFailed": "Das Bild konnte nicht geteilt werden",
  "common.shareYourWeather": "Aktuelles Wetter teilen",
  "common.skip": "Überspringen",
  "common.start": "Start",
  "common.unknown": "Unbekannt",
  "common.validate": "Bestätigen",
  "common.validEmail": "Eine gültige E-Mail-Adresse ist erforderlich.",
  "common.very_low": "Sehr niedrig",
  "common.weatherObservations": "Wetterbeobachtungen",
  "common.welcome": "Willkommen bei SmartMixin!",
  "common.wind": "Wind",
  "common.yes": "Ja",
  "common.zoomImage": "Bild vergrößern",
  "compass.E": "O",
  "compass.E_long": "Ost",
  "compass.ENE": "ONO",
  "compass.ENE_long": "Ostnordost",
  "compass.ESE": "OSO",
  "compass.ESE_long": "Ostsüdost",
  "compass.N": "N",
  "compass.N_long": "Nord",
  "compass.NE": "NO",
  "compass.NE_long": "Nordost",
  "compass.NNE": "NNO",
  "compass.NNE_long": "Nordnordost",
  "compass.NNW": "NNW",
  "compass.NNW_long": "Nordnordwest",
  "compass.NW": "NW",
  "compass.NW_long": "Nordwest",
  "compass.S": "S",
  "compass.S_long": "Süd",
  "compass.SE": "SO",
  "compass.SE_long": "Südost",
  "compass.SSE": "SSO",
  "compass.SSE_long": "Südsüdost",
  "compass.SSW": "SSW",
  "compass.SSW_long": "Südsüdwest",
  "compass.SW": "SW",
  "compass.SW_long": "Südwest",
  "compass.W": "W",
  "compass.W_long": "West",
  "compass.WNW": "WNW",
  "compass.WNW_long": "Westnordwest",
  "compass.WSW": "WSW",
  "compass.WSW_long": "Westsüdwest",
  "dashboard.currentObservations": "Aktuelle Beobachtungen",
  "dashboard.currentRainEvent": "Aktueller Niederschlag",
  "dashboard.currentWeatherConditions": "Aktuelles Wetter",
  "dashboard.customizeDashboard": "Anpassen",
  "dashboard.customizeDashboardDescription": "Ziehen Sie Elemente, um Ihr Dashboard neu anzuordnen. Tippen Sie auf das Augensymbol, um Bereiche ein- oder auszublenden.",
  "dashboard.dashboard": "Übersicht",
  "dashboard.dayRangeExpected": "{value} erwartet um {time}",
  "dashboard.dayRangeReached": "{value} um {time}",
  "dashboard.dayRangeSteady": "Konstant {value} den ganzen Tag",
  "dashboard.hiddenSensors": "Ausgeblendete Sensoren",
  "dashboard.hideSensor": "{sensor} ausblenden",
  "dashboard.lastRainEvent": "Letzter Niederschlag",
  "dashboard.lastVisibleSensor": "Mindestens ein Sensor muss sichtbar bleiben.",
  "dashboard.manageSensors": "Sensoren verwalten",
  "dashboard.manageSensorsDescription": "Ziehen Sie Elemente, um Sensoren neu anzuordnen. Tippen Sie auf das Augensymbol, um Sensoren ein- oder auszublenden. Tippen Sie auf einen Namen, um ihn umzubenennen.",
  "dashboard.manageSensorsDescriptionWeb": "Klicken Sie auf den Stift, um einen Sensor umzubenennen, ziehen Sie ihn am Griff, um die Liste neu anzuordnen, und klicken Sie auf das Auge, um ihn aus- oder einzublenden.",
  "dashboard.moveSensor": "{sensor} verschieben",
  "dashboard.pressureSummary": "Luftdruck-Zusammenfassung",
  "dashboard.rainEvents": "Niederschlagsereignisse",
  "dashboard.rainSummary": "Regen-Zusammenfassung",
  "dashboard.renameSensor": "{sensor} umbenennen",
  "dashboard.shareOutdoorMeasures": "Teilen Sie Ihre Außenmessungen",
  "dashboard.shareOutdoorMeasuresDescription": "Nehmen Sie an der SmartMixin Community teil, um Ihre Außenmessungen anderen Teilnehmern sichtbar zu machen. Messungen der Innentemperatur werden niemals geteilt.",
  "dashboard.showSensor": "{sensor} einblenden",
  "dashboard.temperatureSummary": "Temperatur-Zusammenfassung",
  "dashboard.useDefaultSensorName": "Standardnamen verwenden",
  "dashboard.windSummary": "Wind-Zusammenfassung",
  "devices.batteryLevel": "Batteriestand",
  "devices.firmwareVersion": "Firmware-Version",
  "devices.moduleCount": "{count, plural, one {# Modul} other {# Module}}",
  "devices.moduleType": "Modultyp",
  "devices.noNetatmoWeatherStationYet": "Sie haben noch keine Netatmo Wetterstation.",
  "devices.noOutdoorModule": "Für diese Station gibt es kein funktionierendes Außenmodul.",
  "devices.notReachable": "Nicht erreichbar",
  "devices.serialNumber": "Seriennummer",
  "devices.signalAverage": "Mäßig",
  "devices.signalBad": "Schwach",
  "devices.signalGood": "Gut",
  "devices.signalStrength": "Signalstärke",
  "devices.signalUnknown": "Unbekannt",
  "devices.visitNetatmoWebsite": "Netatmo Webseite",
  "devices.wifiStrength": "Wi-Fi-Stärke",
  "forecastMaps.addColor": "Farbe hinzufügen",
  "forecastMaps.addLayer": "Ebene hinzufügen",
  "forecastMaps.autoDescription": "Das Beste für diese Ansicht",
  "forecastMaps.autoDescriptionFree": "Kostenlose Konten nutzen {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "Jetzt {model}: {previous} deckt {coverage, number, percent} dieser Ansicht ab",
  "forecastMaps.backToMaps": "Zurück zu den Karten",
  "forecastMaps.build": "Erstellen",
  "forecastMaps.buildCompleted": "Erstellung abgeschlossen",
  "forecastMaps.builderMetaDescription": "Erstellen Sie eigene Vorhersagekarten aus den Ebenen der Wettermodelle.",
  "forecastMaps.builderTitle": "Karten-Editor",
  "forecastMaps.buildFailed": "Die Erstellung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "forecastMaps.buildNotPossible": "Diese Karte kann noch nicht erstellt werden — es sind keine Vorhersagedaten verfügbar.",
  "forecastMaps.buildProgress": "Rendern… {completed}/{total} Schritte",
  "forecastMaps.buildStarting": "Erstellung wird gestartet…",
  "forecastMaps.byModel": "Nach Modell",
  "forecastMaps.byZone": "Nach Zone",
  "forecastMaps.colormap": "Farbskala",
  "forecastMaps.colormapCustom": "Eigene Farben",
  "forecastMaps.colormapGroupDomain": "Wetter-Vorlagen",
  "forecastMaps.colormapGroupMatplotlib": "Wissenschaftliche Vorlagen",
  "forecastMaps.colorStop": "Farbe {position}",
  "forecastMaps.configUnavailable": "Diese Vorhersagekarte ist nicht verfügbar. Stattdessen wird {name} angezeigt.",
  "forecastMaps.contourLevels": "Konturstufen",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Frankreich",
  "forecastMaps.countryGermany": "Deutschland",
  "forecastMaps.countryItaly": "Italien",
  "forecastMaps.countryScandinavia": "Skandinavien",
  "forecastMaps.countrySpain": "Spanien",
  "forecastMaps.countrySwitzerland": "Schweiz",
  "forecastMaps.countryUnitedStates": "Vereinigte Staaten",
  "forecastMaps.coverageUnknown": "Gebiet unbekannt",
  "forecastMaps.coversView": "Deckt {coverage, number, percent} dieser Ansicht ab",
  "forecastMaps.customColormapMinColors": "Eine eigene Farbskala benötigt mindestens zwei Farben",
  "forecastMaps.customExtent": "Eigener Ausschnitt",
  "forecastMaps.displayName": "Anzeigename",
  "forecastMaps.downscaling": "Ausdünnungsfaktor der Windfiedern",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Bereich zeichnen",
  "forecastMaps.east": "Ost",
  "forecastMaps.extentDrawHint": "Ziehen Sie auf der Karte, um den Bereich zu zeichnen",
  "forecastMaps.extentInvalid": "West muss kleiner als Ost sein und Süd kleiner als Nord",
  "forecastMaps.frameTime": "Vorhersagezeitpunkt",
  "forecastMaps.height": "Höhe (Zoll)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.inThisArea": "In diesem Gebiet",
  "forecastMaps.invalidHexColor": "Ungültige Farbe — verwenden Sie #RRGGBB",
  "forecastMaps.layerHasErrors": "Diese Ebene enthält Fehler",
  "forecastMaps.layers": "Ebenen",
  "forecastMaps.layerTypeBarbs": "Windfiedern",
  "forecastMaps.layerTypeContour": "Konturlinien",
  "forecastMaps.layerTypeFilledContour": "Gefüllte Konturen",
  "forecastMaps.layerTypeMagnitude": "Betrag",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektorfeld",
  "forecastMaps.leave": "Verlassen",
  "forecastMaps.levelsCount": "Anzahl",
  "forecastMaps.levelsInvalid": "Ungültige Konturstufen",
  "forecastMaps.levelsModeArange": "Feste Schrittweite",
  "forecastMaps.levelsModeExplicit": "Explizite Werte",
  "forecastMaps.levelsModeLinspace": "Gleichmäßig verteilt (Anzahl)",
  "forecastMaps.levelsStep": "Schrittweite",
  "forecastMaps.levelsValues": "Werte",
  "forecastMaps.levelsValuesHint": "Kommagetrennt, aufsteigend",
  "forecastMaps.loadingMaps": "Karten werden geladen…",
  "forecastMaps.localTimeHint": "In Ihrer Ortszeit angezeigt",
  "forecastMaps.lockedConfig": "{model} ist ein Premium-Modell. Stattdessen wird {fallback} angezeigt.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Beschreibung",
  "forecastMaps.mapName": "Kartenname",
  "forecastMaps.mapNameRequired": "Geben Sie einen Namen ein",
  "forecastMaps.mapSettings": "Karteneinstellungen",
  "forecastMaps.maxLayersReached": "Diese Karte hat das Maximum von {max} Ebenen erreicht.",
  "forecastMaps.maxValue": "Maximalwert",
  "forecastMaps.memoryBudgetExceeded": "Die Auflösung überschreitet das Render-Budget — reduzieren Sie DPI oder Höhe",
  "forecastMaps.memoryBudgetUsage": "Render-Budget: {percent}%",
  "forecastMaps.metaDescription": "Animierte Vorhersagekarten aus den Läufen der Wettermodelle.",
  "forecastMaps.metric": "Messgröße",
  "forecastMaps.metricRequired": "Wählen Sie eine Messgröße",
  "forecastMaps.metricUnavailable": "Für dieses Modell nicht verfügbar",
  "forecastMaps.minBelowMax": "Min muss kleiner als Max sein",
  "forecastMaps.minMaxRequired": "Min- und Max-Werte sind für diesen Ebenentyp erforderlich",
  "forecastMaps.minValue": "Minimalwert",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} deckt {coverage, number, percent} dieser Ansicht ab",
  "forecastMaps.modelNoRun": "Noch kein abgeschlossener Lauf",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Nach unten",
  "forecastMaps.moveLayerUp": "Nach oben",
  "forecastMaps.nanClipToMin": "Auf Min begrenzen",
  "forecastMaps.nanMask": "Maskieren",
  "forecastMaps.nanPolicy": "Fehlende Daten",
  "forecastMaps.nanSkip": "Überspringen",
  "forecastMaps.noCompletedRun": "Diese Karte wurde noch nicht erstellt. Bitte später erneut nachsehen.",
  "forecastMaps.noLayers": "Noch keine Ebenen. Fügen Sie eine Ebene hinzu, um zu beginnen.",
  "forecastMaps.noMapsAvailable": "Es sind noch keine Vorhersagekarten verfügbar.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Deckkraft",
  "forecastMaps.openAsAnimation": "Als Animation öffnen",
  "forecastMaps.otherAreas": "Andere Gebiete",
  "forecastMaps.outsideArea": "Deckt dieses Gebiet nicht ab",
  "forecastMaps.overlayLegend": "Legende",
  "forecastMaps.pause": "Pause",
  "forecastMaps.play": "Abspielen",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Die Vorhersage für diesen Punkt konnte nicht geladen werden.",
  "forecastMaps.pointValueLoading": "Vorhersage wird geladen…",
  "forecastMaps.pointValueUnavailable": "Keine Daten für diesen Zeitpunkt.",
  "forecastMaps.premiumModelForView": "{model} deckt diese Ansicht ab",
  "forecastMaps.premiumRequired": "Vorhersagekarten erfordern Premium",
  "forecastMaps.preview": "Vorschau",
  "forecastMaps.previewEmptyHint": "Konfigurieren Sie mindestens eine gültige Ebene, um eine Vorschau zu rendern.",
  "forecastMaps.previewFailed": "Die Vorschau ist fehlgeschlagen",
  "forecastMaps.previewHour": "Vorhersagestunde",
  "forecastMaps.previewRendering": "Vorschau wird gerendert…",
  "forecastMaps.projection": "Projektion",
  "forecastMaps.projectionLambertConformal": "Lambert konform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografisch",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Nordamerika",
  "forecastMaps.removeColor": "Farbe entfernen",
  "forecastMaps.removeLayer": "Ebene entfernen",
  "forecastMaps.retry": "Erneut versuchen",
  "forecastMaps.run": "Lauf: {run}",
  "forecastMaps.runNotDisplayable": "Dieser Lauf kann auf der interaktiven Karte nicht angezeigt werden.",
  "forecastMaps.save": "Speichern",
  "forecastMaps.selectExtentOnMap": "Bereich auf der Karte auswählen",
  "forecastMaps.showArea": "Gebiet zeigen",
  "forecastMaps.showAreaOf": "Gebiet zeigen, {model}",
  "forecastMaps.south": "Süd",
  "forecastMaps.switchToModel": "Zu {model} wechseln",
  "forecastMaps.title": "Vorhersagekarten",
  "forecastMaps.uMetric": "U-Komponente",
  "forecastMaps.unitConversion": "Einheitenumrechnung",
  "forecastMaps.unitNone": "Keine",
  "forecastMaps.unsavedChangesBody": "Sie haben ungespeicherte Änderungen. Verlassen und verwerfen?",
  "forecastMaps.unsavedChangesTitle": "Ungespeicherte Änderungen",
  "forecastMaps.useCurrentView": "Aktuelle Ansicht verwenden",
  "forecastMaps.useModelDomain": "Aus: Es wird das gesamte Modellgebiet verwendet",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U- und V-Messgrößen müssen sich unterscheiden",
  "forecastMaps.valueAtMapCentre": "Wert in der Kartenmitte",
  "forecastMaps.valueBetween": "Muss zwischen {min} und {max} liegen",
  "forecastMaps.variable": "Variable",
  "forecastMaps.variableMissing": "{variable} nicht verfügbar",
  "forecastMaps.variableOnlyFrom": "{variable} kommt nur von {model}",
  "forecastMaps.viewMap": "Karte ansehen",
  "forecastMaps.vMetric": "V-Komponente",
  "forecastMaps.west": "West",
  "forecastMaps.windAnimation": "Windanimation",
  "forecastModels.addForecastModel": "Modell hinzufügen",
  "forecastModels.atYourStations": "An Ihren Stationen verfügbar",
  "forecastModels.comparisonLoadError": "Vorhersagemodell-Vergleich konnte nicht geladen werden",
  "forecastModels.coverageLoading": "Ermitteln, welche Ihrer Stationen jedes Modell abdeckt…",
  "forecastModels.description_AROME": "Météo Frances konvektionsauflösendes hochauflösendes Modell über Westeuropa mit 1,3 km Auflösung. Bestklassig für kurzfristige Vorhersagen in Frankreich; alle drei Stunden aktualisiert.",
  "forecastModels.description_ARPEGE_EU": "Météo Frances europäisches Nest des ARPEGE-Modells mit 10 km Auflösung. Mittelfristige Vorhersagen über Europa, viermal täglich aktualisiert.",
  "forecastModels.description_ARPEGE_GLOBAL": "Météo Frances globales numerisches Wettermodell mit 25 km Auflösung, läuft bis etwa 4 Tage. Viermal täglich aktualisiert.",
  "forecastModels.description_DMI_DINI": "DMIs HARMONIE DINI: ein konvektionsauflösendes Modell über Nordwesteuropa — Dänemark, die Benelux-Staaten, Irland, das Vereinigte Königreich und Skandinavien — mit 2 km Auflösung, das bis zu 60 Stunden läuft, achtmal täglich aktualisiert. Enthält modifizierte offene Daten des DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Environment Canadas Global Deterministic Prediction System: ein weltweites mittelfristiges Modell mit 15 km Auflösung, das bis zu 10 Tage läuft, zweimal täglich aktualisiert.",
  "forecastModels.description_EC_HRDPS": "Environment Canadas High Resolution Deterministic Prediction System: ein konvektionsauflösendes Modell über Kanada und den nördlichen USA mit 2,5 km Auflösung, das bis zu 48 Stunden läuft, viermal täglich aktualisiert.",
  "forecastModels.description_EC_RDPS": "Environment Canadas Regional Deterministic Prediction System: ein mittelfristiges Modell über Nordamerika mit 10 km Auflösung, viermal täglich aktualisiert.",
  "forecastModels.description_ECMWF_HRES": "Das hochauflösende Flaggschiffmodell (IFS) des Europäischen Zentrums für mittelfristige Wettervorhersage, weithin als weltweit führendes globales Vorhersagesystem angesehen. Deckt den gesamten Planeten mit 25 km Auflösung bis zu 15 Tage ab, viermal täglich aktualisiert. Enthält modifizierte offene Daten des ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "NOAAs Flaggschiff-Globalmodell mittlerer Reichweite. Deckt den gesamten Planeten mit 25 km Auflösung bis zu 16 Tage ab, viermal täglich aktualisiert.",
  "forecastModels.description_HRRR_CONUS": "NOAAs High-Resolution Rapid Refresh: ein konvektionsauflösendes Modell über die kontinentalen Vereinigten Staaten mit 3 km Auflösung, stündlich aktualisiert. Am besten geeignet für sehr kurzfristige Vorhersagen von Gewittern und extremem Wetter.",
  "forecastModels.description_ICON": "Das globale ICON-Modell des DWD mit 13 km Auflösung, das den gesamten Planeten bis zu 7,5 Tage abdeckt und viermal täglich aktualisiert wird. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ItaliaMeteos ICON-2I, gemeinsam mit ARPAE betrieben: ein konvektionsauflösendes Modell über Italien mit 2,2 km Auflösung, das bis zu 72 Stunden läuft, zweimal täglich aktualisiert. Enthält offene Daten von ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Der ICON-CH1-EPS-Kontrolllauf von MeteoSwiss: ein konvektionsauflösendes Modell über den Alpen mit 1 km Auflösung, das bis zu 33 Stunden läuft, alle drei Stunden aktualisiert.",
  "forecastModels.description_ICON_CH2": "Der ICON-CH2-EPS-Kontrolllauf von MeteoSwiss: ein konvektionsauflösendes Modell über den Alpen — die Schweiz und die umliegende Alpenregion — mit 2,1 km Auflösung, das bis zu 120 Stunden läuft, viermal täglich aktualisiert.",
  "forecastModels.description_ICON_DE": "DWDs hochauflösendes konvektionsauflösendes Modell über Deutschland und Nachbarländer mit 2,2 km Auflösung. Kurzfristige Vorhersagen, zweimal täglich aktualisiert. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "DWDs europäisches Nest des ICON-Modells mit 7 km Auflösung, das Europa und den Nordatlantik abdeckt. Mittelfristige Vorhersagen, viermal täglich aktualisiert. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Der offene Wettervorhersagedienst des Norwegischen Meteorologischen Instituts, der hochauflösende nordische Modelle mit ECMWF-Daten kombiniert, um weltweite Vorhersagen bis zu 10 Tagen im Voraus zu liefern.",
  "forecastModels.description_MF_AROME_ANTILLES": "AROME-Nest über den französischen Antillen (Guadeloupe, Martinique) mit 2,5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "forecastModels.description_MF_AROME_GUYANE": "AROME-Nest über Französisch-Guayana mit 2,5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "AROME-Nest über Neukaledonien mit 2,5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "forecastModels.description_MF_AROME_POLYNESIE": "AROME-Nest über Französisch-Polynesien mit 2,5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "AROME-Nest über Réunion und Mayotte mit 2,5 km Auflösung. Kurzfristige Vorhersagen, viermal täglich aktualisiert.",
  "forecastModels.description_RRFS_CONUS": "NOAAs Rapid Refresh Forecast System über den kontinentalen USA mit 3 km Auflösung. Stündliche Vorhersagen, achtmal täglich aktualisiert, bis 84 Stunden bei den vier Hauptläufen und 18 Stunden bei den übrigen.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "NOAAs Rapid Refresh Forecast System für ganz Nordamerika mit 13 km Auflösung. Stündliche Vorhersagen bis 84 Stunden, viermal täglich aktualisiert.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Die Flaggschiff-Vorhersage von SmartMixin. Für jede Stunde an Ihrem Standort wählen wir das beste verfügbare Modell aus — typischerweise ein hochauflösendes regionales Modell, sofern vorhanden (AROME in Frankreich, ICON-D2 in Deutschland, HRRR in den USA, ARPEGE Europe auf dem Kontinent…) und greifen anderswo auf ein globales Modell zurück — dann füllen wir alle Lücken aus benachbarten Quellen. Das Ergebnis ist eine einzige nahtlose Vorhersage, die überall auf der Welt bis zu 14 Tage abdeckt, automatisch aktualisiert, wann immer eines der zugrunde liegenden Modelle aktualisiert wird.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Weatherflows proprietäre globale Vorhersage, die mehrere numerische Wettermodelle mit Beobachtungen aus seinem Tempest-Wetterstationsnetz kombiniert. 10-Tage-Horizont weltweit.",
  "forecastModels.everywhereElse": "Überall sonst",
  "forecastModels.everywhereElseFoot": "Wird an jeder Station verwendet, die Ihre bevorzugten Modelle nicht abdecken.",
  "forecastModels.everywhereElsePick": "Eines auswählen",
  "forecastModels.fallbackBlend": "SmartMixin-Mix",
  "forecastModels.fallbackBlendSub": "Kombiniert mehrere Modelle, jedes dort, wo es am stärksten ist.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES überall dort, wo es reicht.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Das globale Modell der NOAA. Was heute jedes Konto verwendet.",
  "forecastModels.fallbackResolution": "Höchste Auflösung",
  "forecastModels.fallbackResolutionSub": "Das feinste verfügbare Gitter an jeder Station.",
  "forecastModels.forecastChipLabelWithRun": "{model}, Lauf {run}",
  "forecastModels.forecastChipRunHint": "Lange drücken, um den neuesten Lauf ein- oder auszublenden",
  "forecastModels.forecastComparisonDescription": "Einfacher Vergleich der Vorhersagen verschiedener Quellen",
  "forecastModels.forecastFollowingPreferences": "Ihren Einstellungen folgend",
  "forecastModels.forecastLoadError": "Vorhersage konnte nicht geladen werden",
  "forecastModels.forecastModel": "Vorhersagemodell",
  "forecastModels.forecastModelAbout": "Über {model}",
  "forecastModels.forecastModelComparison": "Vorhersagemodell-Vergleich",
  "forecastModels.forecastModelCoverage": "Abdeckung",
  "forecastModels.forecastModelDescription": "Beschreibung",
  "forecastModels.forecastModels": "Vorhersagemodelle",
  "forecastModels.forecastModelScopeGlobal": "Global",
  "forecastModels.forecastModelScopeGlobalDescription": "Dieses Modell deckt den gesamten Planeten ab.",
  "forecastModels.forecastModelScopeRegional": "Regional",
  "forecastModels.forecastModelScopeRegionalDescription": "Dieses Modell deckt nur eine bestimmte Region ab.",
  "forecastModels.forecastModelSpecifications": "Spezifikationen",
  "forecastModels.forecastNoPinLocation": "Kein bevorzugtes Modell erreicht diesen Standort — „überall sonst“ entscheidet.",
  "forecastModels.forecastNoPinStation": "Kein bevorzugtes Modell erreicht diese Station — „überall sonst“ entscheidet.",
  "forecastModels.forecastNoPreferredModels": "Noch keine bevorzugten Modelle festgelegt.",
  "forecastModels.forecastOverrideElsewhere": "Überall sonst gelten Ihre Einstellungen.",
  "forecastModels.forecastPickForLocation": "Oder eines für diesen Standort wählen",
  "forecastModels.forecastPickForStation": "Oder eines für diese Station wählen",
  "forecastModels.forecastPinWinsLocation": "{model} — Ihr erstes bevorzugtes Modell, das diesen Standort erreicht.",
  "forecastModels.forecastPinWinsStation": "{model} — Ihr erstes bevorzugtes Modell, das diese Station erreicht.",
  "forecastModels.forecastServedNowHere": "Derzeit ist das hier {model}",
  "forecastModels.forecastSetForLocation": "Für diesen Standort festgelegt",
  "forecastModels.forecastSetForStation": "Für diese Station festgelegt",
  "forecastModels.forecastSettingsRowSub": "Bevorzugte Modelle und was überall sonst gilt",
  "forecastModels.forecastStopUsingHere": "Hier nicht mehr verwenden",
  "forecastModels.forecastUseForLocation": "{model} für diesen Standort verwenden",
  "forecastModels.forecastUseForStation": "{model} für diese Station verwenden",
  "forecastModels.forecastUsePreferred": "Meine bevorzugten Modelle verwenden",
  "forecastModels.frequencyHourly": "Stündlich",
  "forecastModels.horizon": "Horizont",
  "forecastModels.horizonValue": "bis zu {value} Stunden",
  "forecastModels.meshSize": "Rastergröße",
  "forecastModels.pickerShowAll": "Vollständigen Katalog anzeigen",
  "forecastModels.pickerUnreachable": "{count, plural, one {# weiteres Modell erreicht} other {# weitere Modelle erreichen}} keine Ihrer Stationen",
  "forecastModels.pinInUse": "In Verwendung",
  "forecastModels.pinShadowed": "Nie verwendet — ein Modell darüber deckt alle Ihre Stationen ab",
  "forecastModels.pinSlots": "{used} von {max} · Modell auswählen",
  "forecastModels.pinSlotsFull": "{max, plural, one {Der einzige Platz ist belegt. Entfernen Sie sein Modell, um ein anderes hinzuzufügen.} other {Alle # Plätze belegt. Entfernen Sie einen, um einen anderen hinzuzufügen.}}",
  "forecastModels.pinsUncoveredCount": "{used} Ihrer {count, plural, one {# Station} other {# Stationen}}: kein bevorzugtes Modell erreicht {used, plural, one {sie} other {sie}} — „überall sonst“ entscheidet.",
  "forecastModels.pinsUncoveredNamed": "{stations}: kein bevorzugtes Modell erreicht {count, plural, one {sie} other {sie}} — „überall sonst“ entscheidet.",
  "forecastModels.pinUnreachable": "Nie verwendet — es erreicht keine Ihrer Stationen",
  "forecastModels.pinUsedAt": "Verwendet an {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {An Ihrer Station verwendet} other {An allen # Stationen verwendet}}",
  "forecastModels.pinUsedAtSome": "An {used} von {count, plural, one {# Station} other {# Stationen}} verwendet",
  "forecastModels.preferredModels": "Bevorzugte Modelle",
  "forecastModels.preferredModelsAll": "Eine Liste, alle Stationen",
  "forecastModels.preferredModelsOne": "Eine Liste, überall gültig",
  "forecastModels.publisher": "Herausgeber",
  "forecastModels.removePreferredModel": "{model} aus Ihren bevorzugten Modellen entfernen",
  "forecastModels.resetForecastPreference": "Zurücksetzen",
  "forecastModels.resetForecastPreferenceHint": "Löscht Ihre bevorzugten Modelle und kehrt zur SmartMixin-Voreinstellung zurück.",
  "forecastModels.servedNowMany": "Aktuell: GFS {count, plural, one {an Ihrer Station} other {an allen # Stationen}}.",
  "forecastModels.servedNowNone": "Aktuell: überall GFS.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin Multimodell",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow-Vorhersage",
  "forecastModels.weatherForecastModels": "Wettervorhersagemodelle",
  "helpCenter.articleCount": "{count, plural, one {# Artikel} other {# Artikel}}",
  "helpCenter.articleNotFound": "Artikel nicht gefunden",
  "helpCenter.articleNotFoundDescription": "Der gesuchte Artikel existiert nicht.",
  "helpCenter.backToHelpCenter": "Zurück zum Hilfecenter",
  "helpCenter.browseByCategory": "Nach Kategorie durchsuchen",
  "helpCenter.categoryNotFound": "Kategorie nicht gefunden",
  "helpCenter.categoryNotFoundDescription": "Diese Kategorie existiert nicht oder enthält keine Artikel.",
  "helpCenter.contactSupport": "Support kontaktieren",
  "helpCenter.feedbackHelpsImprove": "Ihre Rückmeldung hilft uns, unsere Hilfeartikel zu verbessern.",
  "helpCenter.feedbackReasonNotAnswer": "Er beantwortet meine Frage nicht",
  "helpCenter.feedbackReasonOutdated": "Die Informationen sind veraltet",
  "helpCenter.feedbackReasonUnclear": "Die Anleitung ist unklar",
  "helpCenter.feedbackWhatWentWrong": "Was war das Problem?",
  "helpCenter.helpCategoryAccount": "Konto",
  "helpCenter.helpCategoryBilling": "Abrechnung",
  "helpCenter.helpCategoryForecast": "Prognosen",
  "helpCenter.helpCategoryGettingStarted": "Erste Schritte",
  "helpCenter.helpCategoryProviders": "Anbieter",
  "helpCenter.helpCategoryStations": "Stationen",
  "helpCenter.helpCategoryTroubleshooting": "Fehlerbehebung",
  "helpCenter.helpCenter": "Hilfecenter",
  "helpCenter.landingDescription": "Finden Sie Antworten auf häufige Fragen und erfahren Sie, wie Sie SmartMixin optimal nutzen.",
  "helpCenter.linkToSection": "Link zu diesem Abschnitt",
  "helpCenter.menuItemDescription": "FAQs und Anleitungen",
  "helpCenter.minRead": "{minutes} Min. Lesezeit",
  "helpCenter.onThisPage": "Auf dieser Seite",
  "helpCenter.platformMobileApp": "Mobile App",
  "helpCenter.platformMobileOnly": "Nur in der mobilen App",
  "helpCenter.platformWebApp": "Web-App",
  "helpCenter.platformWebOnly": "Nur in der Web-App",
  "helpCenter.popularArticles": "Beliebte Artikel",
  "helpCenter.relatedArticles": "Verwandte Artikel",
  "helpCenter.searchArticles": "Artikel suchen...",
  "helpCenter.stillNeedHelp": "Benötigen Sie weitere Hilfe?",
  "helpCenter.stillNeedHelpDescription": "Wenn dieser Artikel Ihre Frage nicht beantwortet hat, helfe ich Ihnen gerne direkt weiter.",
  "helpCenter.supportEmailSubject": "SmartMixin-Hilfe",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin-Hilfe — {topic}",
  "helpCenter.thankYouForFeedback": "Vielen Dank für Ihr Feedback!",
  "helpCenter.wasArticleHelpful": "War dieser Artikel hilfreich?",
  "intro.locationDescription": "Aktiviere den Standortzugriff für präzise Vorhersagen, die genau auf deinen Standort zugeschnitten sind — keine allgemeinen Wetterberichte mehr.",
  "intro.locationTitle": "Vorhersagen, die zu dir passen",
  "intro.notificationDescription": "Aktiviere Benachrichtigungen, um rechtzeitig über Wetteränderungen informiert zu werden — Regen, Schnee oder Unwetter, genau dann, wenn es zählt.",
  "intro.notificationsTitle": "Verpasse keinen Wetterumschwung",
  "intro.readyDescription": "Genieße präzise Vorhersagen, Live-Wetterdaten und weltweite Stationsinformationen — alles in einer leistungsstarken App.",
  "intro.readyTitle": "Alles bereit!",
  "intro.welcomeDescription": "Erhalte hyperlokale Vorhersagen von führenden Wetterdiensten — plus Zugriff auf über 40.000 Wetterstationen weltweit, um echte Bedingungen in Vergangenheit und Gegenwart zu sehen.",
  "intro.welcomeTitle": "Dein Wetter, neu gedacht",
  "landing.alsoAvailableOn": "Auch verfügbar auf:",
  "landing.featureAlertsDescription": "Legen Sie benutzerdefinierte Schwellenwerte für jeden Messwert fest. Werden Sie benachrichtigt, wenn die Temperatur sinkt, Regen beginnt oder Wind aufkommt.",
  "landing.featureAlertsTitle": "Intelligente Warnungen",
  "landing.featureAnalyticsDescription": "Interaktive Diagramme, Trendanalysen und detaillierte Statistiken. Tauchen Sie tief in Temperatur-, Feuchtigkeits-, Druck-, Regen- und Winddaten ein.",
  "landing.featureAnalyticsTitle": "Erweiterte Analysen",
  "landing.featureExportDescription": "Erhalten Sie alle Ihre Wetterdaten per E-Mail als Excel-Tabelle, bereit für weitere Analysen in Excel, Google Sheets oder Ihren Lieblingstools.",
  "landing.featureExportTitle": "Daten exportieren",
  "landing.featureForecastDescription": "Zugriff auf {count, plural, one {#+ professionelles Vorhersagemodell} other {#+ professionelle Vorhersagemodelle}} einschließlich ECMWF, GFS und regionaler Modelle. Vergleichen Sie sie nebeneinander für Ihre eigenen Vorhersagen.",
  "landing.featureForecastTitle": "Vorhersagemodelle vergleichen",
  "landing.featureHistoryDescription": "Zugriff auf historische Daten mit stündlicher, täglicher und monatlicher Skala. Exportieren Sie sie nach Excel für Forschung oder persönliche Archive.",
  "landing.featureHistoryTitle": "Umfangreiche Historie",
  "landing.featureMultiBrandDescription": "Verbinden Sie Netatmo, Davis, Tempest, Ecowitt, Ambient Weather und mehr. Kein App-Wechsel mehr nötig.",
  "landing.featureMultiBrandTitle": "Alle Marken, eine App",
  "landing.featuresSubtitle": "SmartMixin gibt Ihnen die Werkzeuge, um Ihre Wetterdaten wie ein Profi zu analysieren, vergleichen und verstehen.",
  "landing.featuresTitle": "Für Datenliebhaber gebaut",
  "landing.finalCtaButton": "Kostenloses Konto erstellen",
  "landing.finalCtaSubtitle": "Schließen Sie sich Tausenden von Wetterenthusiasten an, die SmartMixin vertrauen.",
  "landing.finalCtaTitle": "Bereit, tiefer in Ihre Wetterdaten einzutauchen?",
  "landing.heroCta": "Kostenlos starten",
  "landing.heroDescription": "Tiefgehende Analysen, schöne Diagramme und professionelle Vorhersagen — alle Ihre Wetterstationen in einer leistungsstarken App vereint.",
  "landing.heroSecondaryCta": "Karte erkunden",
  "landing.heroTagline": "Für Wetterenthusiasten",
  "landing.heroTitle": "Sehen Sie Ihr Wetter wie nie zuvor",
  "landing.pricingComparisonCaption": "Funktionen von Kostenlos und Premium im Vergleich",
  "landing.pricingFeatureAdvancedMetrics": "Erweiterte Metriken",
  "landing.pricingFeatureAlerts": "Benutzerdefinierte Warnungen",
  "landing.pricingFeatureColumn": "Funktion",
  "landing.pricingFeatureExport": "Datenexport (Excel)",
  "landing.pricingFeatureForecastComparison": "Vorhersagevergleich",
  "landing.pricingFeatureForecasts": "Vorhersagemodelle",
  "landing.pricingFeatureForecastsFreeTier": "1 Modell",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ Modell} other {#+ Modelle}}",
  "landing.pricingFeatureReports": "Analysen & Berichte",
  "landing.pricingFeatureStationComparison": "Stationsvergleich",
  "landing.pricingFeatureWidgets": "Startbildschirm-Widgets",
  "landing.pricingFeatureYearOverYear": "Jahresvergleich",
  "landing.pricingFreeCta": "Loslegen",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Beliebteste",
  "landing.pricingPremiumCta": "Loslegen",
  "landing.pricingPremiumDescription": "Ab 1,99 €/Monat — abonnieren Sie im Web, App Store oder Google Play",
  "landing.pricingSubtitle": "Starten Sie kostenlos, upgraden Sie, wenn Sie mehr Power brauchen.",
  "landing.pricingTitle": "Einfache, transparente Preise",
  "landing.statBrands": "Unterstützte Marken",
  "landing.statForecasts": "Vorhersagemodelle",
  "landing.statStations": "Wetterstationen",
  "landing.supportedDevicesNote": "Dazu mehr als {count, number} öffentliche Stationen aus dem Netz der Weltorganisation für Meteorologie",
  "landing.supportedDevicesSubtitle": "Verbinden Sie Ihre bestehende Wetterstation in wenigen Minuten. Wir unterstützen {count, plural, one {# große Marke} other {# große Marken}}, und es werden mehr.",
  "landing.supportedDevicesTitle": "Funktioniert mit Ihrer Station",
  "metrics.absolutePressure": "Absoluter Luftdruck",
  "metrics.airDensity": "Luftdichte",
  "metrics.airGap": "Luftabstand",
  "metrics.apparentTemperature": "Gefühlte Temperatur",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Durchschn.",
  "metrics.avg_wind": "Mittlerer Wind",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Schwarzkugeltemperatur",
  "metrics.boilerOn": "Heizung EIN",
  "metrics.boilerOnInHours": "Heizung EIN (Stunden)",
  "metrics.cloudCover": "Bewölkung",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Leitfähigkeit",
  "metrics.dailyPrecipitation": "Tagesniederschlag",
  "metrics.dailyRain": "Tagesregen",
  "metrics.degreeDayShort": "HGT",
  "metrics.depth": "Tiefe",
  "metrics.depthSensors": "Tiefensensoren",
  "metrics.dewPoint": "Taupunkt",
  "metrics.distance": "Entfernung",
  "metrics.downTrend": "sinkend",
  "metrics.ET": "Gesamtverdunstung (ET)",
  "metrics.etToday": "ET heute",
  "metrics.feelsLike": "gef. Temp.",
  "metrics.feelsLikeWithFormula": "gef. Temp. ({formula})",
  "metrics.frostPoint": "Frostpunkt",
  "metrics.gust": "Böe",
  "metrics.gustDirection": "Böenrichtung",
  "metrics.hail": "Hagel",
  "metrics.heatIndex": "Hitze-Index",
  "metrics.heatingDegreeDays": "Heizgradtage",
  "metrics.heatingPower": "Heizleistung",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Luftfeuchtigkeit",
  "metrics.lastLightningImpact": "Letzter Einschlag",
  "metrics.lastMeasure": "Letzte Messung",
  "metrics.leafSensors": "Blattsensoren",
  "metrics.leafWetness": "Blattnässe",
  "metrics.lightningDistance": "Entfernung",
  "metrics.lightningStrikeCount": "Anzahl der Blitzeinschläge",
  "metrics.lightningStrikeDistance": "Blitzentfernung",
  "metrics.max": "Max.",
  "metrics.max_gust": "Max. Böe",
  "metrics.maxToday": "Max. heute",
  "metrics.min": "Min.",
  "metrics.noise": "Lautstärke",
  "metrics.normalizedHeatingCoefficient": "Normierter Heizkoeffizient",
  "metrics.outdoorTemperature": "Außentemperatur",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2,5",
  "metrics.precipitation": "Niederschlag",
  "metrics.pressure": "Druck",
  "metrics.rain": "Regen",
  "metrics.rainDurationValue": "Regendauer: {duration}",
  "metrics.rainfallMeasurement": "Niederschlagsmessung",
  "metrics.rainRate": "Regenrate",
  "metrics.relativePressure": "Relativer Druck",
  "metrics.setPoint": "Sollwert",
  "metrics.snow": "Schnee",
  "metrics.snowfall": "Schneefall",
  "metrics.soilMoisture": "Feuchtigkeit",
  "metrics.soilSensors": "Bodensensor",
  "metrics.soilWaterTension": "Bodenwasserspannung",
  "metrics.solarEnergy": "Sonnenenergie",
  "metrics.solarRadiation": "Sonnenstrahlung",
  "metrics.speed": "Geschwindigkeit",
  "metrics.stableTrend": "Stabil",
  "metrics.sum": "Summe",
  "metrics.temperature": "Temperatur",
  "metrics.temperatureSensors": "Temperatur & Feuchtigkeits-Sensoren",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "steigend",
  "metrics.uv": "UV",
  "metrics.visibility": "Sichtweite",
  "metrics.weatherCondition": "Wetterzustand",
  "metrics.wetBulbGlobeTemperature": "Feuchtkugelglobetemperatur",
  "metrics.wetBulbTemperature": "Feuchtkugeltemperatur",
  "metrics.wind": "Wind",
  "metrics.windChill": "Windchill",
  "metrics.windDirection": "Windrichtung",
  "metrics.windMeasurement": "Windmessung",
  "metrics.windRun": "Windweg",
  "metrics.windRunDescription": "Der Windweg ist die Gesamtstrecke, die der Wind über einen bestimmten Zeitraum zurücklegt",
  "metrics.windSpeed": "Windgeschwindigkeit",
  "navigation.allFavorites": "Alle anzeigen",
  "navigation.breadcrumbs": "Brotkrümelnavigation",
  "navigation.collapseNavigation": "Navigation einklappen",
  "navigation.expandNavigation": "Navigation ausklappen",
  "navigation.main": "Hauptmenü",
  "navigation.mapShort": "Karte",
  "navigation.skipToContent": "Zum Hauptinhalt springen",
  "navigation.stationsShort": "Stationen",
  "network.cancelError": "Anfrage wurde storniert",
  "network.connectionError": "Server nicht verfügbar",
  "network.networkError": "Netzwerk nicht verfügbar",
  "network.serverError": "Es gab ein Problem...",
  "network.timeoutError": "Verbindungszeitüberschreitung",
  "network.unknownError": "Unbekannter Fehler",
  "premium.alreadyPremium": "Sie haben bereits ein Premium-Konto!",
  "premium.bestValue": "Bestes Angebot",
  "premium.billingDetailsAndroid": "Kostenloser Testzeitraum: Es fallen keine Kosten an, wenn Sie mindestens 24 Stunden vor Ende des Testzeitraums kündigen. Danach verlängert sich Ihr SmartMixin-Abonnement automatisch, sofern Sie es nicht mindestens 24 Stunden vor Ende des laufenden Zeitraums kündigen; kündigen können Sie jederzeit in den Einstellungen Ihres Google Play-Kontos. Jede Verlängerung wird zu dem Preis berechnet, der auf der Schaltfläche oben angezeigt wird. Die Zahlung wird Ihrem Google Play-Konto bei Bestätigung des Kaufs und zu Beginn jedes Verlängerungszeitraums belastet.",
  "premium.billingDetailsIos": "Kostenloser Testzeitraum: Es fallen keine Kosten an, wenn Sie mindestens 24 Stunden vor Ende des Testzeitraums kündigen. Danach verlängert sich Ihr SmartMixin-Abonnement automatisch, sofern Sie es nicht mindestens 24 Stunden vor Ende des laufenden Zeitraums kündigen; kündigen können Sie jederzeit in den Einstellungen Ihres App Store-Kontos. Jede Verlängerung wird zu dem Preis berechnet, der auf der Schaltfläche oben angezeigt wird. Die Zahlung wird Ihrem App Store-Konto bei Bestätigung des Kaufs und zu Beginn jedes Verlängerungszeitraums belastet.",
  "premium.freeBannerBody": "Kostenlose Konten erhalten überall GFS — Ihre bevorzugten Modelle und „überall sonst“ greifen, sobald Sie ein Abo abschließen.",
  "premium.freeBannerTitle": "Einstellungen gelten mit Premium",
  "premium.freeSubscription": "Kostenloses Premium-Abo",
  "premium.freeTrialForPeriod": "Kostenloser Testzeitraum für {period, plural, one {# Tag} other {# Tage}}",
  "premium.getUnlimitedAccess": "Unbegrenzten Zugang zu:",
  "premium.manageMySubscription": "Mein Abonnement verwalten",
  "premium.notPurchasedYet": "Für dieses Store-Konto wurde kein Kauf von SmartMixin Premium gefunden.",
  "premium.orChooseMonthly": "Oder monatlich wählen:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Aktiv",
  "premium.premiumAnnualTrialInfo": "Starten Sie mit einem kostenlosen Testzeitraum von {days, plural, one {# Tag} other {# Tagen}}",
  "premium.premiumCurrentPlan": "Aktueller Plan",
  "premium.premiumDownloadApp": "Laden Sie die App herunter, um zu abonnieren:",
  "premium.premiumEndsOn": "Läuft am {date} ab",
  "premium.premiumFeatureAlerts": "Wetterwarnungen",
  "premium.premiumFeatureAnalysis": "Erweiterte Wetteranalyse",
  "premium.premiumFeatureCharts": "Diagrammvergleiche",
  "premium.premiumFeatureExport": "Datenexport",
  "premium.premiumFeatureForecast": "Regionale Vorhersagemodelle",
  "premium.premiumFeatureNotification": "Statusleisten-Widget",
  "premium.premiumFeatureTitle": "Premium-Funktion",
  "premium.premiumFeatureWidgets": "Startbildschirm-Widgets",
  "premium.premiumFreePlan": "Kostenlos",
  "premium.premiumInactive": "Kein Abonnement",
  "premium.premiumManageStoreSubscription": "Sie haben über {store} abonniert. Dort können Sie Ihr Abo verwalten oder kündigen.",
  "premium.premiumManageWebSubscription": "Verwalten Sie Ihr Abonnement, aktualisieren Sie die Zahlungsmethode oder kündigen Sie.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Verlängert am {date}",
  "premium.premiumSubscribeAnnual": "Jährlich — 9,99 €/Jahr",
  "premium.premiumSubscribedOn": "Abonniert auf {platform}",
  "premium.premiumSubscribedOnWeb": "Im Web abonniert",
  "premium.premiumSubscribeMonthly": "Monatlich — 1,99 €/Monat",
  "premium.premiumSubscribeOnWeb": "Jetzt abonnieren, um alle Premium-Funktionen freizuschalten.",
  "premium.premiumSubscriptionSuccess": "Ihr Abonnement wurde aktiviert! Genießen Sie alle Premium-Funktionen.",
  "premium.premiumSubscriptionSuccessTitle": "Willkommen bei Premium!",
  "premium.premiumWebappNotice": "Ein Abo im Web ist derzeit nicht verfügbar.",
  "premium.pricePerMonth": "{price}/Monat",
  "premium.pricePerYear": "{price}/Jahr",
  "premium.purchasedNetatmoPro": "Sie haben zuvor Netatmo Pro gekauft ({date}). Damit haben Sie Zugriff auf einen Teil der Premium-Funktionen. Abonnieren Sie eines der folgenden Angebote, wenn Sie Zugriff auf alle Premium-Funktionen haben möchten.",
  "premium.purchaseFailed": "Ihr Kauf konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
  "premium.restoreFailed": "Ihre Käufe konnten nicht wiederhergestellt werden. Bitte versuchen Sie es erneut.",
  "premium.restorePurchase": "Kauf wiederherstellen",
  "premium.savingsPercent": "Sparen Sie {percent}%",
  "premium.seePremium": "Premium ansehen",
  "premium.startFreeTrial": "Kostenlos testen",
  "premium.storeUnavailable": "Der Store ist gerade nicht erreichbar. Bitte versuchen Sie es später erneut.",
  "premium.subscribeNow": "Jetzt abonnieren — ohne Testphase",
  "premium.switchToPremium": "Zu SmartMixin Premium wechseln",
  "premium.thenPrice": "dann {price}",
  "providerHints.ambientWeatherApiKey": "In den Kontoeinstellungen von ambientweather.net erstellt.",
  "providerHints.davisApiSecret": "Wird nur einmal beim Erstellen des V2-API-Schlüssels angezeigt — sicher aufbewahren.",
  "providerHints.davisV2ApiKey": "Von der V2-API-Schlüsselseite auf weatherlink.com.",
  "providerHints.ecowittApi": "Von der API-Seite Ihres Ecowitt-Kontos.",
  "providerHints.ecowittApp": "Der Anwendungs-Schlüssel, ebenfalls aus Ihrem Ecowitt-Konto.",
  "providerHints.myAcuriteCredentialsBanner": "Verwenden Sie E-Mail und Passwort Ihres My AcuRite-Kontos — nicht Ihren SmartMixin-Login.",
  "providerHints.myAcuriteEmail": "Die E-Mail-Adresse Ihres My AcuRite-Kontos — nicht Ihr SmartMixin-Login.",
  "providerHints.myAcuritePassword": "Das Passwort Ihres My AcuRite-Kontos.",
  "providerHints.weatherflowToken": "Persönlicher Token von tempestwx.com → Einstellungen → Datenautorisierungen.",
  "providerHints.wundergroundEditKey": "Anderen Schlüssel verwenden",
  "providerHints.wundergroundKey": "Eine lange Zeichenfolge von Ihrer Weather Underground API-Schlüssel-Seite — nicht Ihr wunderground.com-Passwort.",
  "providerHints.wundergroundKeyExample": "z. B. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-Schlüssel verifiziert",
  "providerHints.wundergroundNoStationsNearby": "Keine Stationen in der Nähe gefunden. Versuchen Sie, direkt eine Stations-ID einzugeben.",
  "providerHints.wundergroundStationIdExample": "z. B. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Holen Sie Ihren Ambient Weather API-Schlüssel.",
  "providerIntro.davisStep2": "Holen Sie Ihren Davis V2-API-Schlüssel und API-Secret.",
  "providerIntro.ecowittStep2": "Holen Sie Ihren Ecowitt API- und Anwendungs-Schlüssel.",
  "providerIntro.getStarted": "Loslegen",
  "providerIntro.myAcuriteStep2": "Verwenden Sie E-Mail und Passwort Ihres bestehenden My AcuRite-Kontos.",
  "providerIntro.netatmoEnergyStep2": "Bei Aufforderung bei Netatmo anmelden — kein API-Schlüssel erforderlich.",
  "providerIntro.netatmoWeatherStep2": "Bei Aufforderung bei Netatmo anmelden — kein API-Schlüssel erforderlich.",
  "providerIntro.signupBanner": "Fast geschafft — erstellen Sie Ihr kostenloses SmartMixin-Konto, um {provider} zu verbinden.",
  "providerIntro.step1": "Melden Sie sich bei Ihrem SmartMixin-Konto an (NICHT Ihr {provider}-Login).",
  "providerIntro.step3EmailPassword": "Hier eingeben.",
  "providerIntro.step3KeyOrToken": "Hier einfügen.",
  "providerIntro.step3OAuth": "Autorisieren Sie SmartMixin im Popup-Fenster.",
  "providerIntro.step3Wunderground": "Fügen Sie Ihren API-Schlüssel ein und wählen Sie dann eine Station in der Nähe oder geben Sie eine beliebige Stations-ID ein.",
  "providerIntro.stepOfTotal": "Schritt {step} von {total}",
  "providerIntro.title": "{provider} verbinden",
  "providerIntro.weatherflowStep2": "Holen Sie Ihren Tempest-Token zur persönlichen Nutzung.",
  "providerIntro.wundergroundBrowsePublic": "Keine Station? Öffentliche Stationen durchsuchen",
  "providerIntro.wundergroundFindNearby": "Stationen in meiner Nähe finden",
  "providerIntro.wundergroundOrEnterId": "Oder Stations-ID eingeben",
  "providerIntro.wundergroundStep2": "Holen Sie Ihren Weather Underground API-Schlüssel. Sie können dann jede beliebige Station verbinden — Ihre eigene oder eine öffentliche.",
  "reports.agroMeteorology": "Agrarmeteorologie",
  "reports.analysis": "Analyse",
  "reports.annualCumulativeRainfallComparison": "Vergleich jährlich kumulierter Niederschlag",
  "reports.annualHeatingDurationComparison": "Jährlicher Vergleich der Heizdauer",
  "reports.annualHeatingEfficiency": "Jährliche Heiz-Effizienz",
  "reports.annualIndoorComparison": "Jahresweiser Innenvergleich",
  "reports.annualOutdoorComparison": "Jahresweiser Außenvergleich",
  "reports.annualOutdoorReport": "Jahresweiser Außenbericht",
  "reports.annualReport": "Jahresbericht",
  "reports.annualSolarReport": "Jährlicher Solarbericht",
  "reports.annualWaterBalance": "Jährliche Wasserbilanz",
  "reports.annualWaterBalanceCarryOver": "Übernehmen {year} ({value})",
  "reports.annualWaterBalanceDescription": "Die Wasserbilanz (vereinfachte Version, nur Regen und Evapotranspiration werden berücksichtigt) hilft bei der Steuerung der Wasserversorgung",
  "reports.avgHumidity": "Durchschn. Feuchtigkeit",
  "reports.avgMaxTemperature": "Durchschn. T°max",
  "reports.avgMetric": "Durchschnitt – {metric}",
  "reports.avgMinTemperature": "Durchschn. T°min",
  "reports.avgPressure": "Durchschn. Luftdruck",
  "reports.avgTemperature": "Durchschnittstemperatur",
  "reports.chartsAndTable": "Diagramme und Tabelle",
  "reports.climateNormalPeriodOfRecord": "Messzeitraum ({years, plural, one {# Jahr} other {# Jahre}})",
  "reports.climateNormals": "Klimanormalwerte",
  "reports.climateNormalStandardLabel": "Normalperiode ({period})",
  "reports.climateTrendPerDecade": "Temperaturtrend: {value} pro Jahrzehnt über {years, plural, one {# Jahr} other {# Jahre}}",
  "reports.coldestMonthRanking": "Kältester {month} seit Messbeginn",
  "reports.comfortable": "Komfortabel (45% {lessThan} Luftfeuchtigkeit ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulierter Niederschlag",
  "reports.cumulativeRainfallDescription": "Verfolgen Sie die Gesamtniederschlagsmenge, die sich über den gewählten Zeitraum ansammelt.",
  "reports.dailyMaxRainfall": "Max. Tagesniederschlag",
  "reports.dataExport": "Datenexport",
  "reports.dataExportXlsxFormatDescription": "Exportieren Sie alle Daten Ihrer Station im Excel-Format (* .xlsx). Sobald Sie auf den Button klicken, erhalten Sie nach einigen Minuten eine EMail mit den verarbeiteten Daten.",
  "reports.daysOfData": "{days, plural, one {# Tag} other {# Tage}} Daten",
  "reports.daysWithFrost": "Tage mit Frost",
  "reports.daysWithHeavyRain": "Tage mit Starkregen (≥ {threshold})",
  "reports.daysWithoutThaw": "Tage mit Dauerfrost",
  "reports.daysWithStrongFrost": "Tage mit starkem Frost",
  "reports.emailSent": "Eine EMail wurde an Sie gesendet",
  "reports.frostDays": "Frosttage",
  "reports.grasslandTemperatureSum": "Grünland-Temperatur-Summe",
  "reports.grasslandTemperatureSumDescription": "Wird im Frühjahr die Summe von {threshold} überschritten, ist damit der nachhaltige Vegetationsbeginn erreicht",
  "reports.growingDegreeDays": "Wachstumsgradtage",
  "reports.highPressure": "Hochdruck (Durchschnittsdruck ≥ {threshold})",
  "reports.iceDays": "Eistage",
  "reports.indoorReport": "Innenbericht",
  "reports.keyFacts": "Schlüsselwerte",
  "reports.longestDrySpell": "Längste Trockenperiode",
  "reports.longestRunOfRainyDays": "Längste Dauer Regentage",
  "reports.longestRunWithoutRun": "Längste Dauer Trockenheit",
  "reports.longestWetSpell": "Längste Regenperiode",
  "reports.lowPressure": "Tiefdruck (Durchschnittsdruck {lessThan} {threshold})",
  "reports.maxHumidity": "Höchste Luftfeuchtigkeit",
  "reports.maxMetric": "Maximum – {metric}",
  "reports.maxPressure": "Höchster Luftdruck",
  "reports.maxTemperature": "Maximaltemperatur",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Größte Schwankung (/24H)",
  "reports.minHumidity": "Niedrigste Luftfeuchtigkeit",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Niedrigster Luftdruck",
  "reports.minTemperature": "Minimaltemperatur",
  "reports.minTempMagnitude24h": "Kleinste Schwankung (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Noch # Tag} other {Noch # Tage}} in diesem Monat",
  "reports.monthlyAverageCountdownDetail": "Dann erscheinen der Monatsdurchschnitt und seine Platzierung.",
  "reports.monthlyAverageRule": "Monatsdurchschnitte und Platzierungen erscheinen, sobald ein Kalendermonat {days, plural, one {# erfassten Tag} other {# erfasste Tage}} hat.",
  "reports.monthlyHeatingEfficiency": "Monatliche Heiz-Effizienz",
  "reports.monthlyOutdoorReport": "Monatsweiser Außenbericht",
  "reports.monthlyReport": "Monatlicher Bericht",
  "reports.monthlySolarReport": "Monatlicher Solarbericht",
  "reports.monthlyWindReport": "Monatlicher Windbericht",
  "reports.monthsOfData": "{months, plural, one {# Monat} other {# Monate}} Daten",
  "reports.numberOfDays": "Anzahl der Tage",
  "reports.outdoorReport": "Außen-Bericht",
  "reports.overviewSection": "Übersicht",
  "reports.rainfall": "Niederschlag",
  "reports.rainyDays": "Regentage",
  "reports.recordClimatologicalDay": "Klimatologischer Tag (06–06 UTC)",
  "reports.recordClimDayBody": "Regen wird hier pro Kalendertag summiert, Mitternacht bis Mitternacht Stationszeit. Wetterdienste summieren von 06:00 bis 06:00 UTC – ein Unwetter um Mitternacht kann daher einen anderen Tag zum regenreichsten machen.",
  "reports.recordDailyRain": "Regenreichster Tag",
  "reports.recordFromHourlyReadings": "Aus Stundenwerten",
  "reports.recordHigh": "Wärmerekord",
  "reports.recordLow": "Kälterekord",
  "reports.recordOfficialBody": "Der Wetterdienst veröffentlicht für diese Station tägliche Höchst- und Tiefstwerte, gemessen mit Maximum- und Minimumthermometern. Sie erfassen kurze Spitzen, die stündliche Messungen verpassen, und ersetzen daher die aus Stundenwerten ermittelten Werte.",
  "reports.recordOfficialValue": "Offizieller Wert",
  "reports.recordsAndClimatology": "Rekorde & Klima",
  "reports.recordSheetTitle": "Über diese Rekorde",
  "reports.recordsSince": "Rekorde seit {date}",
  "reports.recordWindGust": "Stärkste Windböe",
  "reports.relativelyWet": "Höhere Luftfeuchtigkeit (60% {lessThan} Luftfeuchtigkeit ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# Bericht} other {# Berichte}}",
  "reports.sendEmail": "EMail senden",
  "reports.summerDays": "Sommertage",
  "reports.tableScrollRegion": "{title}, horizontal scrollbar",
  "reports.tooDry": "Zu trocken (Luftfeuchtigkeit ≤ 45%)",
  "reports.tooWet": "Zu feucht (Luftfeuchtigkeit {greaterThan} 80%)",
  "reports.tropicalNights": "Tropische Nächte",
  "reports.unlockPremiumSubtitle": "In SmartMixin Premium enthalten",
  "reports.unlockPremiumTitle": "{count, plural, one {# Premium-Funktion} other {# Premium-Funktionen}} freischalten",
  "reports.warmestMonthRanking": "Wärmster {month} seit Messbeginn",
  "reports.waterBalance": "Wasserbilanz",
  "reports.yearsOfData": "{years, plural, one {# Jahr} other {# Jahre}} Daten",
  "reports.yearToDateTemperatureComparison": "Temperaturvergleich seit Jahresbeginn",
  "sensors.bgtSensors": "Schwarzkugel & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareHumidity": "Luftfeuchtigkeit vergleichen",
  "sensors.compareMoisture": "Bodenfeuchtigkeit vergleichen",
  "sensors.comparePm25": "PM2.5 vergleichen",
  "sensors.compareTemperatures": "Temperaturen vergleichen",
  "sensors.compareWaterTension": "Bodenwasserspannung vergleichen",
  "sensors.depthByChannel": "Tiefe nach Kanal",
  "sensors.heatStressExtreme": "Extremer Hitzestress",
  "sensors.heatStressModerate": "Mäßiger Hitzestress",
  "sensors.heatStressNone": "Kein Hitzestress",
  "sensors.heatStressStrong": "Starker Hitzestress",
  "sensors.heatStressVeryStrong": "Sehr starker Hitzestress",
  "sensors.indoorClimate": "Raumklima",
  "sensors.indoorCo2Levels": "CO2-Werte",
  "sensors.indoorTemperatureAndHumidity": "Temperatur & Luftfeuchtigkeit",
  "sensors.leafWetnessByChannel": "Blattfeuchte nach Kanal",
  "sensors.lightningSensor": "Blitz",
  "sensors.moistureByChannel": "Bodenfeuchtigkeit nach Kanal",
  "sensors.noDataAvailable": "Keine Daten verfügbar",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 nach Kanal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Kanal auswählen",
  "sensors.sensorDetailDescription": "Historische Daten und Trends für Ihre Sensorkanäle anzeigen.",
  "sensors.sensorHistory": "Sensorverlauf",
  "sensors.soilConductivityByChannel": "Leitfähigkeit nach Kanal",
  "sensors.soilTemperatureByChannel": "Bodentemperatur nach Kanal",
  "sensors.strikesToday": "Einschläge heute",
  "sensors.temperatureByChannel": "Temperatur nach Kanal",
  "sensors.viewChart": "Diagramm anzeigen",
  "sensors.waterTensionByChannel": "Bodenwasserspannung nach Kanal",
  "settings.appearance": "Erscheinungsbild",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arabisch",
  "settings.bulgarian": "Bulgarisch",
  "settings.catalan": "Katalanisch",
  "settings.chartGestures": "Gesten auf Diagrammen",
  "settings.chartGesturesDescription": "Wischen in Diagrammen ändert den Zeitraum, Zusammenziehen mit zwei Fingern ändert die Zeitskala",
  "settings.choiceCount": "{count, plural, one {# verfügbar} other {# verfügbar}}",
  "settings.contactUs": "Kontakt",
  "settings.contactUsDescription": "Hilfe erhalten oder Feedback senden",
  "settings.croatian": "Kroatisch",
  "settings.czech": "Tschechisch",
  "settings.dailyDetailByPeriods": "Tagesdetails nach Abschnitten",
  "settings.dailyDetailByPeriodsDescription": "Die 24 Stunden in Nacht, Morgen, Nachmittag und Abend gruppieren — dieselbe Aufteilung, die auch die Tageszusammenfassung verwendet.",
  "settings.danish": "Dänisch",
  "settings.dark": "Dunkle Darstellung",
  "settings.dataDisplay": "Datenanzeige",
  "settings.dateAndTime": "Datum und Uhrzeit",
  "settings.donateButton": "Spenden",
  "settings.donateDescription": "SmartMixin wird von einem kleinen Team entwickelt. Wenn es Ihnen nützlich ist, können Sie die Entwicklung mit einer einmaligen Spende in beliebiger Höhe unterstützen. Es ist ein Geschenk — es ändert Ihren Tarif nicht und schaltet keine Funktionen frei.",
  "settings.donateSuccessBody": "Ihre Spende hilft dabei, SmartMixin am Laufen zu halten und weiter zu verbessern. Wir wissen das sehr zu schätzen.",
  "settings.donateSuccessTitle": "Vielen Dank für Ihre Unterstützung!",
  "settings.donateTitle": "SmartMixin unterstützen",
  "settings.dragToReorder": "Zum Umsortieren ziehen",
  "settings.dutch": "Niederländisch",
  "settings.english": "Englisch",
  "settings.french": "Französisch",
  "settings.german": "Deutsch",
  "settings.gestures": "Gesten",
  "settings.greek": "Griechisch",
  "settings.hungarian": "Ungarisch",
  "settings.italian": "Italienisch",
  "settings.japanese": "Japanisch",
  "settings.korean": "Koreanisch",
  "settings.language": "Sprache",
  "settings.languageDescription": "Bevorzugte Sprache",
  "settings.light": "Helle Darstellung",
  "settings.measurementUnits": "Maßeinheiten",
  "settings.netatmoDashboard": "Netatmo-Übersicht",
  "settings.netatmoLayoutCards": "Kartenliste",
  "settings.netatmoLayoutCardsDescription": "Eine Karte pro Modul, alles in einer Liste",
  "settings.netatmoLayoutClassic": "Klassisch",
  "settings.netatmoLayoutClassicDescription": "Zwei Karten, zwischen Modulen wischen",
  "settings.netatmoNewLayoutNotice": "Neues Layout: eine Karte pro Modul.",
  "settings.netatmoSwitchBackToClassic": "Zurück zu Klassisch",
  "settings.netatmoSwitchToLayout": "Zu {layout} wechseln",
  "settings.norwegian": "Norwegisch",
  "settings.notificationsSection": "Benachrichtigungen",
  "settings.ongoingNotificationEnabled": "Dauerhafte Benachrichtigung aktivieren",
  "settings.ongoingNotificationMetrics": "Angezeigte Messwerte",
  "settings.ongoingNotificationPermissionRequired": "Benachrichtigungsberechtigung erforderlich",
  "settings.ongoingNotificationPreviewHint": "Vorschau — schalten Sie das Widget ein, um es anzuzeigen",
  "settings.ongoingNotificationStatusBar": "Statusleiste",
  "settings.polish": "Polnisch",
  "settings.portuguese": "Portugiesisch",
  "settings.preferencesSection": "Präferenzen",
  "settings.privacyPolicy": "Datenschutzerklärung",
  "settings.russian": "Russisch",
  "settings.serbian": "Serbisch",
  "settings.settings": "Einstellungen",
  "settings.settingsPageTitle": "Einstellungen - {page}",
  "settings.slovak": "Slowakisch",
  "settings.smallDecimals": "Kleine Dezimalstellen",
  "settings.smallDecimalsDescription": "Dezimalziffern in kleinerer Größe anzeigen",
  "settings.spanish": "Spanisch",
  "settings.statusBarWidget": "Statusleisten-Widget",
  "settings.statusBarWidgetDescription": "Immer sichtbare Wetterdaten",
  "settings.subscriptionSection": "Abonnement",
  "settings.supportSection": "Support",
  "settings.swedish": "Schwedisch",
  "settings.systemTheme": "Systemdarstellung",
  "settings.termsOfService": "Nutzungsbedingungen",
  "settings.themeDarkShort": "Dunkel",
  "settings.themeLightShort": "Hell",
  "settings.themeSystemShort": "System",
  "settings.turkish": "Türkisch",
  "settings.ukrainian": "Ukrainisch",
  "settings.units": "Einheiten",
  "settings.unitsDescription": "In der Anwendung angezeigte Maßeinheiten",
  "settings.update": "Aktualisieren",
  "settings.windDirectionConvention": "Windrichtungspfeil",
  "settings.windDirectionConventionDescription": "Anzeige der Windrichtungspfeile wählen",
  "settings.windDirectionMeteorological": "Ursprungsrichtung",
  "settings.windDirectionMeteorologicalDescription": "Pfeil zeigt, woher der Wind kommt (meteorologische Konvention)",
  "settings.windDirectionOceanographic": "Strömungsrichtung",
  "settings.windDirectionOceanographicDescription": "Pfeil zeigt, wohin der Wind weht (ozeanographische Konvention)",
  "stations.addAStation": "Station hinzufügen",
  "stations.addToFavorites": "Zu Favoriten hinzufügen",
  "stations.addYourOwnStation": "Eigene Station hinzufügen",
  "stations.clearRecentLocations": "Alle löschen",
  "stations.clearSearch": "Suche löschen",
  "stations.currentLocation": "Aktueller Standort",
  "stations.customizedStationName": "Benutzerdefinierter Stationsname",
  "stations.favoriteLocations": "Favoriten",
  "stations.favoriteLocationsEmpty": "Sie können bis zu 5 Lieblingsorte hinzufügen.",
  "stations.favoriteStations": "Stationen auf Favoriten-Liste",
  "stations.filterStationDescription": "Zeigen Sie keine Stationen mit unzuverlässigen Messungen an.",
  "stations.filterStations": "Stationen filtern",
  "stations.filterStationSourceDescription": "Wählen Sie Stationsanbieter aus, die Sie auf der Karte anzeigen möchten",
  "stations.findStationsNearYou": "Stationen in Ihrer Nähe finden",
  "stations.hiddenStations": "Versteckte Stationen",
  "stations.hiddenStationsDescription": "Sie können eine Station wieder einblenden, indem Sie auf das Augensymbol daneben tippen.",
  "stations.hideStationNamed": "{station} ausblenden",
  "stations.lastSeen": "zuletzt {time}",
  "stations.loadingStation": "Station wird geladen…",
  "stations.location": "Standort",
  "stations.locationAddedToFavorites": "Standort zu Favoriten hinzugefügt",
  "stations.locationNotGranted": "Die Standortberechtigung wurde nicht erteilt. Bitte erlauben Sie den Zugriff auf Ihren Standort in den Geräteeinstellungen.",
  "stations.locationRemovedFromFavorites": "Standort aus Favoriten entfernt",
  "stations.locations": "Standorte",
  "stations.locationUnavailable": "Ihr Standort konnte nicht ermittelt werden. Bitte überprüfen Sie die Geräteeinstellungen.",
  "stations.maxFavoriteLocationsReached": "Sie können nur bis zu 5 Lieblingsorte haben. Entfernen Sie einen, um einen anderen hinzuzufügen.",
  "stations.modifyFavoriteStations": "Lieblingsstationen ändern",
  "stations.modifyFavoriteStationsDescription": "Sie können Ihre Lieblingsstationen durch Ziehen neu anordnen. Sie können sie auch aus der Liste entfernen.",
  "stations.myLocation": "Mein Standort",
  "stations.nearbyWeatherStations": "Nahe gelegene Wetterstationen",
  "stations.noLocationsFound": "Keine Orte gefunden",
  "stations.noLongerReported": "Nicht mehr gelistet",
  "stations.noLongerReportedBy": "Seit {date} nicht mehr bei {provider} gelistet",
  "stations.noSearchResults": "Keine Artikel entsprechen Ihrer Suche",
  "stations.noStationsFound": "Keine Stationen gefunden",
  "stations.noWeatherStationYet": "Sie haben noch keine Wetterstation.",
  "stations.recentLocations": "Zuletzt verwendet",
  "stations.recentLocationsEmpty": "Ihr Verlauf ist leer.",
  "stations.removeFromFavorites": "Von Favoriten entfernen",
  "stations.removeStationNamed": "{station} von Favoriten entfernen",
  "stations.reorderStationNamed": "{station} verschieben",
  "stations.searchForLocation": "Nach einem Standort suchen",
  "stations.searchForWeatherStation": "Nach einer Wetterstation suchen",
  "stations.searchResults": "Suchergebnisse",
  "stations.searchResultsEmpty": "Keine Ergebnisse gefunden.",
  "stations.searchResultsFound": "{count, plural, one {# Ergebnis gefunden} other {# Ergebnisse gefunden}}",
  "stations.searchStationsDescription": "Geben Sie eine Stadt, Adresse oder einen Ortsnamen ein, um Wetterstationen in der Nähe zu finden.",
  "stations.searchStationsHint": "Verwenden Sie die Suchleiste oben, um Wetterstationen an jedem Ort der Welt zu entdecken.",
  "stations.selectStationForComparison": "Wählen Sie eine Vergleichsstation",
  "stations.stationAddedToFavorites": "Station zu Favoriten hinzugefügt",
  "stations.stationCount": "{count, plural, one {# Station} other {# Stationen}}",
  "stations.stationInformation": "Stationsinformationen",
  "stations.stationName": "Stationsname",
  "stations.stationObservationsDescription": "Zeigen Sie die neuesten Beobachtungen von Wetterstationen an",
  "stations.stationRemovedFromFavorites": "Station aus Favoriten entfernt",
  "stations.stationsLoading": "Stationen werden geladen",
  "stations.stationsNear": "Stationen in der Nähe von {place}",
  "stations.stationType": "Stationstyp",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Veraltet",
  "stations.tryAnotherLocation": "Wir konnten keine Wetterstationen in der Nähe dieses Ortes finden. Versuchen Sie, nach einem anderen Gebiet zu suchen.",
  "stations.unhideStationNamed": "{station} wieder einblenden",
  "stations.weatherStation": "Wetterstation",
  "stations.weatherStationCount": "{count, plural, one {# Wetterstation} other {# Wetterstationen}}",
  "stations.weatherStations": "Stationen",
  "stations.welcomeConnectService": "Besitzen Sie eine Wetterstation? Verbinden Sie Ihren Dienst",
  "stations.welcomeSubtitle": "Ihr Wetter, alles an einem Ort",
  "thermostat.away": "Unterwegs",
  "thermostat.boilerOn": "Heizung EIN",
  "thermostat.hg": "Frostschutz",
  "thermostat.homeInformation": "Informationen zum Zuhause",
  "thermostat.homeName": "Name des Zuhauses",
  "thermostat.manualBoost": "Manueller Boost",
  "thermostat.manualSetpointUntil": "Manueller Sollwert bis",
  "thermostat.noThermostatYet": "Sie haben noch keinen Netatmo Thermostat",
  "thermostat.relay": "Relais",
  "thermostat.room": "Raum",
  "thermostat.rooms": "Räume",
  "thermostat.smartThermostat": "Smart Thermostat",
  "thermostat.smartValve": "Smart Valve",
  "thermostat.whenBackHome": "Wann sind Sie wieder zu Hause?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Zoll",
  "units.inchOfMercury": "Zoll Quecksilber",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilometer pro Stunde",
  "units.knot": "Knoten",
  "units.meterPerSecond": "Meter pro Sekunde",
  "units.milePerHour": "Meilen pro Stunde",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter Quecksilber",
  "weatherConditions.blizzard": "Schneesturm",
  "weatherConditions.blowingDust": "Aufgewirbelter Staub",
  "weatherConditions.blowingSnow": "Schneetreiben",
  "weatherConditions.breezy": "Frischer Wind",
  "weatherConditions.clear": "Klar",
  "weatherConditions.cloudy": "Bedeckt",
  "weatherConditions.drizzle": "Nieselregen",
  "weatherConditions.flurries": "Leichter Schneefall",
  "weatherConditions.foggy": "Nebel",
  "weatherConditions.freezingDrizzle": "Gefrierender Nieselregen",
  "weatherConditions.freezingRain": "Gefrierender Regen",
  "weatherConditions.frigid": "Eisige Kälte",
  "weatherConditions.hail": "Hagel",
  "weatherConditions.haze": "Dunst",
  "weatherConditions.heavyRain": "Starker Regen",
  "weatherConditions.heavySnow": "Starker Schneefall",
  "weatherConditions.hot": "Hitze",
  "weatherConditions.hurricane": "Hurrikan",
  "weatherConditions.isolatedThunderstorms": "Einzelne Gewitter",
  "weatherConditions.mixedRainAndHail": "Regen und Hagel",
  "weatherConditions.mostlyClear": "Überwiegend klar",
  "weatherConditions.mostlyCloudy": "Überwiegend bewölkt",
  "weatherConditions.mostlySunny": "Überwiegend sonnig",
  "weatherConditions.notAvailable": "Wetterbedingungen nicht verfügbar",
  "weatherConditions.partlyCloudy": "Teilweise bewölkt",
  "weatherConditions.rain": "Regen",
  "weatherConditions.rainSleet": "Regen und Eiskörner",
  "weatherConditions.rainSnow": "Regen und Schnee",
  "weatherConditions.scatteredShowers": "Verstreute Schauer",
  "weatherConditions.scatteredSnowShowers": "Verstreute Schneeschauer",
  "weatherConditions.scatteredThunderstorms": "Verstreute Gewitter",
  "weatherConditions.showers": "Schauer",
  "weatherConditions.sleet": "Eiskörner",
  "weatherConditions.smoke": "Rauch",
  "weatherConditions.snow": "Schnee",
  "weatherConditions.snowShowers": "Schneeschauer",
  "weatherConditions.strongStorms": "Schwere Gewitter",
  "weatherConditions.sunny": "Sonnig",
  "weatherConditions.thunderstorms": "Gewitter",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tropensturm",
  "weatherConditions.windy": "Windig",
  "weatherConditions.wintryMix": "Winterlicher Mischniederschlag",
  "weatherMap.clusterMarkerName": "{metric} {value}, Median von {count, plural, one {# Station} other {# Stationen}}, vergrößern",
  "weatherMap.legendHeavy": "Stark",
  "weatherMap.legendLight": "Leicht",
  "weatherMap.legendLightningHelp": "Die Farbe zeigt das Alter jedes Blitzes der letzten {minutes} Minuten — die neuesten in Weiß, die ältesten in Dunkelrot.",
  "weatherMap.legendNewest": "Neueste",
  "weatherMap.legendOldest": "Älteste",
  "weatherMap.legendStationsHelp": "Die Markerfarbe entspricht dem Wert der ausgewählten Messgröße.",
  "weatherMap.lightningDataAttribution": "Blitzdaten: Blitzortung.org",
  "weatherMap.lightningStrikes": "Blitzeinschläge",
  "weatherMap.lightningStrikesDescription": "Blitzeinschläge in Echtzeit auf der Karte anzeigen",
  "weatherMap.mapLayers": "Kartenebenen",
  "weatherMap.mapLegend": "Kartenlegende",
  "weatherMap.mapMode": "Kartenmodus",
  "weatherMap.mapNameForecast": "Vorhersagekarte, {model}, {variable}",
  "weatherMap.mapNameObservations": "Wetterkarte, Beobachtungen",
  "weatherMap.modeForecast": "Vorhersage",
  "weatherMap.modeObservations": "Beobachtungen",
  "weatherMap.radarDataAttribution": "Radardaten: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Radarzeitpunkt",
  "weatherMap.rainRadar": "Regenradar",
  "weatherMap.rainRadarDescription": "Regenradar-Overlay auf der Karte anzeigen",
  "weatherMap.resetBearing": "Ziehen, um die Karte zu drehen, klicken, um nach Norden auszurichten",
  "weatherMap.showingForecast": "Angezeigte Vorhersage: {model}, {variable}",
  "weatherMap.signInForecastBody": "Mit einem SmartMixin-Konto sind GFS-Karten kostenlos. Weitere Modelle gibt es mit Premium.",
  "weatherMap.signInForecastTitle": "Melden Sie sich an, um Vorhersagekarten zu sehen",
  "weatherMap.stationMarkerName": "{metric} {value}, eine Station",
  "weatherMap.stationMarkersHint": "Mit den Pfeiltasten wechseln Sie zwischen den Stationen",
  "weatherMap.stationMarkerWindValue": "{speed}, aus {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain ist eine zusätzliche Datenquelle, die über das Tempest Weather System bereitgestellt wird und auf der Nearcast Technology basiert. Die NC-Rain-Daten sind eine Schätzung der durchschnittlichen Niederschlagsmenge rund um Ihr Tempest auf Nachbarschaftsebene",
  "weatherMap.weatherMap": "Wetterkarte",
  "weatherMap.weatherMapMetaDescription": "SmartMixin bietet interaktive Wetterkarten und Regenradar für Wetterbedingungen weltweit.",
  "weatherMap.zoomIn": "Vergrößern",
  "weatherMap.zoomOut": "Verkleinern",
  "weatherWarnings.activeNow": "Jetzt aktiv",
  "weatherWarnings.agencyMessage": "Meldung des Wetterdienstes",
  "weatherWarnings.areaCovered": "Betroffenes Gebiet",
  "weatherWarnings.areaThisLocation": "{area} (dieser Ort)",
  "weatherWarnings.areaYourStation": "{area} (Ihre Wetterstation)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Amtliche Warnung, {severity}: {hazard}} one {Amtliche Warnung, {severity}: {hazard}, und # weitere} other {Amtliche Warnung, {severity}: {hazard}, und # weitere}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Bevorstehende amtliche Warnung, {severity}: {hazard}} one {Bevorstehende amtliche Warnung, {severity}: {hazard}, und # weitere} other {Bevorstehende amtliche Warnung, {severity}: {hazard}, und # weitere}}",
  "weatherWarnings.crumb": "Amtliche Warnungen",
  "weatherWarnings.emptyBody": "Der nationale Wetterdienst hat für diesen Ort derzeit keine Warnung herausgegeben. Wir prüfen alle paar Minuten erneut.",
  "weatherWarnings.emptyTitle": "Keine amtlichen Warnungen",
  "weatherWarnings.ended": "Abgelaufen",
  "weatherWarnings.endedAt": "Diese Warnung ist {time} abgelaufen.",
  "weatherWarnings.errorBody": "Prüfen Sie Ihre Verbindung. Wir versuchen es alle paar Minuten erneut.",
  "weatherWarnings.errorTitle": "Amtliche Warnungen konnten nicht geladen werden",
  "weatherWarnings.fromTime": "Ab {time}",
  "weatherWarnings.hazardAirQuality": "Luftqualität",
  "weatherWarnings.hazardAvalanche": "Lawinen",
  "weatherWarnings.hazardCoastalEvent": "Küstengefahren",
  "weatherWarnings.hazardFlood": "Hochwasser",
  "weatherWarnings.hazardFog": "Nebel",
  "weatherWarnings.hazardForestFire": "Waldbrände",
  "weatherWarnings.hazardHighTemperature": "Hohe Temperaturen",
  "weatherWarnings.hazardLowTemperature": "Tiefe Temperaturen",
  "weatherWarnings.hazardOther": "Sonstige Gefahr",
  "weatherWarnings.hazardRain": "Regen",
  "weatherWarnings.hazardSnowIce": "Schnee und Glätte",
  "weatherWarnings.hazardThunderstorm": "Gewitter",
  "weatherWarnings.hazardUv": "UV-Strahlung",
  "weatherWarnings.hazardWind": "Wind",
  "weatherWarnings.hideHazards": "Gefahren ausblenden",
  "weatherWarnings.issuedBy": "Herausgegeben von {sender}",
  "weatherWarnings.lastUpdate": "Letzte Aktualisierung: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Karte des betroffenen Gebiets: {area}.} other {Karte der # betroffenen Gebiete. {area} ist hervorgehoben.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Karte des betroffenen Gebiets.} other {Karte der # betroffenen Gebiete.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Karte nicht verfügbar. Das Gebiet ist unten aufgeführt.} other {Karte nicht verfügbar. Die # Gebiete sind unten aufgeführt.}}",
  "weatherWarnings.moreHazards": "+ {count} weitere: {hazards}",
  "weatherWarnings.notInLanguage": "Nicht auf {language} verfügbar. So angezeigt, wie der Wetterdienst sie veröffentlicht hat.",
  "weatherWarnings.openOn": "Auf {site} öffnen",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # weiteres Gebiet} other {+ # weitere Gebiete}}",
  "weatherWarnings.severityExtreme": "Extrem",
  "weatherWarnings.severityFrom": "{severity} ab {time}",
  "weatherWarnings.severityMinor": "Gering",
  "weatherWarnings.severityModerate": "Mäßig",
  "weatherWarnings.severityNow": "{severity} jetzt",
  "weatherWarnings.severitySevere": "Schwer",
  "weatherWarnings.severityUntil": "{severity} bis {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {# Gebiet anzeigen} other {Alle # Gebiete anzeigen}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {# Gebiet auf der Karte anzeigen} other {Alle # Gebiete auf der Karte anzeigen}}",
  "weatherWarnings.showHazards": "Gefahren anzeigen",
  "weatherWarnings.showPeriods": "{count, plural, one {# Zeitraum anzeigen} other {Alle # Zeiträume anzeigen}}",
  "weatherWarnings.source": "Quelle: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, danach {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# amtliche Wetterwarnung} other {# amtliche Wetterwarnungen}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Amtliche Wetterwarnungen",
  "weatherWarnings.todayAt": "heute um {time}",
  "weatherWarnings.tomorrow": "Morgen",
  "weatherWarnings.tomorrowAt": "morgen um {time}",
  "weatherWarnings.upcoming": "Bevorstehend",
  "weatherWarnings.viewAll": "Alle amtlichen Warnungen",
  "weatherWarnings.whatToDo": "Handlungsempfehlungen"
}
